import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener, Inject,
  Input,
  OnDestroy,
  OnInit,
  Output, Type,
  ViewChild
} from '@angular/core';
import { ScrollToTopService } from 'src/app/shared/services/scroll-to-top.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { readStorage, removeStorage, StorageArea, writeStorage } from 'src/app/shared/utils/safe-storage';
import { MatPaginator } from '@angular/material/paginator';
import { Store, select } from '@ngrx/store';
import { isEmptyObject, isNullOrUndefined, isPlainObject } from 'is-what';
import * as _ from 'lodash';
import {
  Subject,
  Observable,
  debounceTime,
  distinctUntilChanged,
  merge,
  map,
  catchError,
  throwError, interval, BehaviorSubject, EMPTY, filter, switchMap, forkJoin, of, finalize, race, tap, timer
} from 'rxjs';
import {
  SelectionMode,
  TableAction,
  TableEvent,
  TableConfig,
  TableField,
  TableActionType
} from 'src/app/core/models/table-config';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { selectAuth } from 'src/app/store/auth/auth.reducers';
import { DynaConfActionType, DynaCrudRequest, State, captureOwnerCode, selectFeatureCode } from 'src/app/store/shared/shared.reducers';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';
import { TableSelection, TableData, TableStatus } from '../table/table.component';
import { Auth } from 'src/app/auth/models/auth';
import { OperationType, SortDirection } from 'src/app/core/models/dynacrud';
import { SortArrowDirection, directionFromPrioritisedSort, prioritisedSortFromEcho, secondarySortDirection, secondarySortRank } from 'src/app/shared/utils/sort-direction';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import {
  Condition, convertirAHexadecimal,
  Entity,
  Holo, keyDialog, KEYCONSTANTSETINSERT, Language,
  Product,
  ProductStructure,
  ProductStructureField,
  Warehouse, WarehouseSession
} from 'src/app/shared/models/entities';
import { ProductStructureService } from 'src/app/structure/services/product-structure.service';
import { blockWhileListingDrafts } from 'src/app/core/services/draft-listing-block';
import { NgForm, NgModel } from '@angular/forms';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import {
  AUTO_STRATEGY,
  AUTO_WAREHOUSE,
  AUTO_WAREHOUSE_ID,
  describeAllocationSplit,
  isAutoForced,
  isAutoWarehouse,
  warnOnSentinelWarehouseCollision,
} from '../../../services/auto-allocation.util';
import { WarehouseMovementDTORequired } from "../../../../features/warehouse/models/entities";
import { SetInsertService, Loads, TypeSaveInsert } from "../../../services/set-insert.service";
import { DynacrudApiWrapper } from "../../../api/dynacrud-api";
import { SetInsertDraftService, PendingDraft } from "../../../services/set-insert-draft.service";
import { getTabId, peekTabId } from '../../../services/tab-id';
import { DraftPreviewConfig, DEFAULT_PREVIEW_CONFIG, previewConfigForKey } from "../../../services/draft-features";
import { toDraftPreviewItem } from "./draft-preview-item";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseAction } from "../../../../store/store.actions";
import { ColumnFieldComponent } from "../Column";
import { SharedService } from "../../../../shared/services/shared.service";
import { LayoutActionType } from "../../../../store/layout/layout.reducers";
import { take } from 'rxjs';
import { hasStoredImage } from 'src/app/shared/utils/image-url';


enum TypeEditTable {
  COMMENT = 'COMMENT',
  QUANTITY = 'QUANTITY',
  WAREHOUSES = 'WAREHOUSES', //warehouseToId
  HOLOS = 'HOLOS',
  LANGUAGE = 'LANGUAGE',
  CONDITION = 'CONDITION', //conditionId
  LANGUAGEROW = 'languageRow',
  CONDITIONROW = 'conditionRow',
  PURCHASEPRICE = 'PURCHASEPRICE'

}

const [keepSelectAll, keepValue, keepValueComment, keepValueWarehouse, keepValueQuantity, keepValuePurchasePrice] = ['keepSelectAll', 'keep', 'keepValueComment', 'keepValueWarehouse', 'keepValueQuantity', 'keepValuePurchasePrice']

/** How long a draft restore waits for `ProductStructureService` to finish loading before it paints
 *  anyway — see `productStructuresReady`, which explains why the restore path (unlike the normal
 *  one) gets exactly one attempt and why proceeding beats waiting forever. */
export const PRODUCT_STRUCTURES_READY_TIMEOUT_MS = 10000;

export interface ColumnFieldNormal {
  $field: string;
  $editable: boolean;
  $label: string;
  $sortable: boolean;
  $id: string;
  $type?: Type<ColumnFieldComponent>;
  $sortExpression?: string;
  $typeField?: string | Type<any>;
}
export const KeepHeaderValues = 'headerValues';
export const VisibleColumnsKeyPrefix = 'setInsertVisibleColumns:';

/**
 * Written into an area whose `removeItem` was refused, so the stale value it still holds cannot
 * come back: every reader here treats it as "this area keeps nothing".
 *
 * It is un-collidable by CONSTRUCTION rather than by being an unlikely word: it lives only in the
 * `KeptKeyPrefix` slot, where every value this build stores carries `KeptValuePrefix`, so a stored
 * string that LACKS the prefix there cannot have come from a value the operator typed. Picking a
 * rare-looking literal was not enough on its own — an operator whose "comment for all" was exactly
 * this text had it read back as "nothing kept", the one kept value to vanish while every other one
 * restored. A value under the un-namespaced (pre-namespace) key is never compared against it at
 * all: that slot is read verbatim, so an earlier build's copy of this text restores as the comment
 * it is.
 *
 * Deliberately NOT `''`. An empty string is a LEGITIMATE stored value — clearing the "comment for
 * all" box persists exactly that — and before the prefix the two were indistinguishable, so a
 * comment the operator deliberately cleared in this tab read as a tombstone, fell through to the
 * shared `localStorage` copy another tab had written, and was stamped back onto every selected row
 * and committed. A readable word rather than a control character: nothing stops `'\u0000'` from
 * being stored, but it is illegal in XML 1.0, so a spec that ever prints it takes the JUnit
 * reporter (and with it the whole CI run) down with an `assertLegalChar` throw.
 */
export const KeptTombstone = '__keptRemoved__';

/**
 * The wire-level belt for the movement bulk/single endpoints — `isUnsendable`, the numeric
 * coercions and the two "rendered but refused" predicates — now lives in
 * `shared/utils/movement-payload`, because `POST /v2/sessions/{id}/movementsbulk` has a SECOND
 * caller (the transfer/unload action, via `AddMovementService.saveMovementBulk`) that assembled
 * its payload verbatim while every guard sat in this file. Re-exported here so the existing
 * importers of this module keep resolving; new callers should import from the shared module.
 */
export {
  isUnsendable, coerceQuantity, isUsableQuantity, coercePurchasePrice, isNegativePurchasePrice,
  isBlockedQuantity,
} from 'src/app/shared/utils/movement-payload';
// A re-export creates no local binding, so this file imports what it uses itself.
import {
  isUnsendable, coerceQuantity, isUsableQuantity, coercePurchasePrice, isNegativePurchasePrice,
  isBlockedQuantity, toNumeric,
} from 'src/app/shared/utils/movement-payload';

/**
 * The property every grid row carries a stable identity in, and the counter that mints them.
 *
 * A commit has to remember WHICH rows it carried so its success path blanks those and only those
 * (`reset`), and the in-flight spinner has to name the row it belongs to. Neither can use the
 * positional index — `clonedRow`/`deletedRow` splice the array mid-flight and every later row
 * shifts — and neither can use the row OBJECT, because almost every write to `copyProducts`
 * replaces the rows wholesale with `_.cloneDeep` (`clonedRow`, `deletedRow`, `getValues` when the
 * lookup arrays arrive). A reference-keyed set matched nothing after any of those, so the rows a
 * commit had just saved stayed filled and valid and the next Save all re-sent them as duplicate
 * warehouse movements.
 *
 * A plain enumerable string property survives `_.cloneDeep` (a symbol or a non-enumerable one
 * would not, which is the whole point), and is stamped by the `copyProducts` setter so every
 * assignment route is covered rather than each call site individually. It never reaches the wire:
 * `getModel` builds its payload field by field and does not spread the row.
 *
 * That same enumerability is why it is PERSISTED, and why both the key and the mint are as short
 * as they are. The rows are the store slot's own objects and the `${appVersion}_stat` blob is
 * re-serialized on every non-router action, so the stamp is paid per row per dispatch: `"__rowUid":
 * "r-a1b2c3-137",` is ~26 characters against the several hundred a grid row already serializes.
 * Nothing shorter is available without giving up one of the two properties this identity rests on
 * — a side `WeakMap`/`Map` keyed on the row object keeps the blob clean but is exactly the
 * reference-keyed shape the paragraph above rules out (every `_.cloneDeep` of `copyProducts` would
 * orphan it), and a non-enumerable property is dropped by that same clone.
 *
 * The uid carries a PER-PAGE-LOAD random token, not a bare counter. Rows are the store slot's own
 * objects, mutated in place, so a stamp leaks into the persisted `${appVersion}_stat` blob and
 * comes back on rehydrate — while the counter restarts at 0 with every page load. A bare
 * `row-${++n}` therefore COLLIDED with a rehydrated `row-1` after F5: a per-row save of either
 * row locked and spun both, and its success `reset()` blanked the never-saved twin, wiping what
 * the operator had typed. A stamp from a previous load is deliberately kept (the guard below):
 * it is still unique against every mint of THIS load, and re-stamping would orphan any in-flight
 * bookkeeping keyed on it.
 */
export const ROW_UID = '__rowUid';
let rowUidCounter = 0;
/** Minted once per page load — makes every uid of this load distinct from any uid a rehydrated
 *  store blob (or a duplicated tab's copy of one) carries from a previous load. Six base-36
 *  characters: the uid is stamped onto persisted rows (see above), and the token only has to be
 *  distinct from the handful of loads whose stamps can still be sitting in the blob, not globally
 *  unique. */
const ROW_UID_LOAD_TOKEN = Math.random().toString(36).slice(2, 8);

/**
 * Prefix stamped onto every kept header value in storage, so no value a user can TYPE is ever
 * equal to the tombstone below.
 *
 * Without it the tombstone lived in the same slot as the values and was compared against the raw
 * string, so a "comment for all" whose text happened to be the sentinel read back as "this area
 * keeps nothing" — the kept comment silently vanished while every other kept value restored.
 *
 * It is only unambiguous because it lives under `KeptKeyPrefix`, where nothing but this build ever
 * writes. Stripping it from whatever the un-namespaced key held would corrupt every kept value an
 * earlier build stored that happens to START with the prefix letter — `vendita fiera` restores as
 * `endita fiera`, is stamped onto every selected row and is committed with the movements.
 */
export const KeptValuePrefix = 'v';

/**
 * Storage-key namespace for kept header values written by this build.
 *
 * The prefix above can only be stripped safely from a slot that is guaranteed to carry it, and a
 * shared key cannot give that guarantee: a value stored by an earlier release is unprefixed and
 * indistinguishable from a prefixed one (both are just strings, and both can start with `v`).
 * Namespacing the KEY makes the two generations separate slots — `getKeptFrom` reads this one
 * first and decodes it, falls back to the un-namespaced key and returns it verbatim, then migrates
 * it here so the fallback is taken at most once per key.
 */
export const KeptKeyPrefix = 'kept.';

/**
 * Encoding prefix for a LOCAL copy that supersedes the per-tab one — "local wins".
 *
 * `getKeptFrom` reads session first because per-tab recency normally wins, and the write-through
 * keeps the two areas equal. The one place they diverge with the SESSION copy stale is a refused
 * session write whose stale value also refuses to be cleared (removal and tombstone both refused —
 * reads keep working in that mode, so the stale copy stays readable and would be served first,
 * painted onto every selected row and committed). The write is the only moment that staleness is
 * PROVABLE, and localStorage — which just accepted the fresh value — is the only durable channel
 * left, so the fresh local copy is marked as superseding right in its own slot: no extra keys, no
 * extra reads, and the very next session write that succeeds rewrites both copies plainly, which
 * heals the marker.
 *
 * The marker carries the WRITING TAB's id (`w<tabId>|<value>`), and only that tab honours it. The
 * staleness the refused write proves is a fact about ONE sessionStorage — the writing tab's own —
 * while the marked copy lives in localStorage, which every tab of the origin reads: an unscoped
 * marker written by tab A superseded tab B's perfectly healthy per-tab value, painted A's number
 * onto B's selected rows, and B's own write-through then persisted it into B's session, making the
 * override stick. Another tab decodes the marked copy as a PLAIN local value (session-first order
 * back in force), so the fresh value still seeds new tabs the way any local copy does. A marker
 * whose id cannot be read as this tab's (foreign, absent, or this tab has no id yet) proves
 * nothing here — `peekTabId`, never `getTabId`: reading someone else's marker is not a reason to
 * claim an id.
 *
 * Only a value under `KeptKeyPrefix` can carry it (same reasoning as `KeptValuePrefix`), and only
 * a `local` copy is ever WRITTEN with it. Mirror-image residual, accepted: if local later becomes
 * unwritable-and-unclearable while session recovers, a stale marked copy can pin an old value —
 * the same exotic mode in the opposite area, which the previous behaviour handled no better.
 *
 * Second accepted residual (review 2026-08-12): a RELOAD inside the refusing mode defeats the
 * tab scoping, because the tab id lives in the SAME refusing sessionStorage — a refused id write
 * survives only in memory (`tab-id.ts` calls losing it on reload the accepted degradation), so
 * the reloaded tab mints a fresh id, `w<oldId>|fresh` no longer decodes as this tab's marker, and
 * the unclearable stale session copy is served first again until the next accepted session write
 * heals it. Closing it would need the id durable in the very storage that is refusing writes —
 * there is no such channel. The window is one tab, in a storage-refusing browser mode, across a
 * reload, until the first accepted write; the pre-marker behaviour served the stale copy in that
 * mode unconditionally.
 */
export const KeptWinsPrefix = 'w';

/**
 * Ends the tab id inside a wins-marked value. The FIRST occurrence splits id from value — the id
 * never contains it (`generateTabId` mints UUIDs or base36), the operator's value may.
 */
export const KeptWinsSeparator = '|';

/** The namespaced storage key a kept value lives under. Exported for specs, which otherwise have
 *  to hardcode the layout they are asserting on. */
export const keptStorageKey = (key: string): string => KeptKeyPrefix + key;
type WarehouseMovementDTORequiredPrev = Omit<WarehouseMovementDTORequired, "warehouseFromId">;
interface SortItem {
  field: TableField;
  position: number;
  direction: SortDirection;
}
interface SortStatus {
  [id: string]: SortItem;
}
export type Roles = Pick<Auth, "roles">;
export interface CLEANOBJECT { [k: string]: any };

@Component({
  selector: 'app-table-edit-rows',
  templateUrl: './table-edit-rows.component.html',
  styleUrls: ['./table-edit-rows.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableEditRowsComponent implements OnInit, AfterViewInit, OnDestroy {

  featureCode: string | undefined = '';
  setAvailable = false;
  selection: TableSelection = { all: false, rows: [] };
  tableData: TableData = { data: [], tableStatus: { page: { pageIndex: 0, pageSize: 0, length: 0 }, sort: [] } };
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  selectMode = SelectionMode.single;
  sortStatus: { [id: string]: SortItem } = {};

  selectionStatus: { [prop: string]: { row: any, selected: boolean | undefined } } = {};
  loadAll = false;
  sessionId: number | undefined;
  comentsValue = '';
  isOpen: { [key: string]: any } = {};
  /** `null`, not just `undefined`: `appNumberInput` emits null for an emptied box, and denying
   *  that in the type is what let `'' + value` write the literal 'null' into storage in the first
   *  place. Keeping the declaration honest is what stops the next `v.toFixed(2)` from crashing. */
  quantityValue: number | null | undefined;
  productStructure: ProductStructure | undefined;
  errorCustomHolo: { [k: string]: any } = {};
  errorCustomLingua: { [k: string]: any } = {};
  errorCustomCondizione: { [k: string]: any } = {};
  allsValidValue = 0;
  private copyProductsValue: Product[] = [];
  productSelectValue: { [key: string]: any } = {};
  productSelectValueAll!: boolean;
  entityAll: Warehouse | undefined;
  errorCustomAll = false;
  @ViewChild('genericFieldAll') genericFieldAll!: NgModel;
  errorCustom: { [k: string]: boolean } = {};
  loadingAll = false;
  valueFiledAll: { [key: string]: any } = {};
  validKeyValue = '';
  loadingSave = false;
  youCanReload = false;
  validProductsProp: any[] = [];
  existLoad = false;
  noPaginationAndSort = false;
  firstLoadItems = true;
  secondLoadItems = true;
  resetValueOnFireSubject = new BehaviorSubject<boolean>(false);
  resetValueOnFireObs = this.resetValueOnFireSubject.asObservable();
  valuePagueIndex = 1;
  fullAuth!: Auth;
  /** True when the user's role makes automatic allocation mandatory (env-configured, empty today). */
  autoForced = false;
  canLoadNormal = true;
  firstLoads = true;
  persistValueOn: boolean = false;
  visibleColumns = new Set<string>();
  columnMenuOpen = false;
  loadingType: { [k: string]: boolean } = {};
  /** Nullable for the same reason as `quantityValue` — the number directive emits null. */
  purchasePriceValue: number | null | undefined;

  /** Up only while `resetHeader` is clearing the header controls.
   *
   *  The header setters exist to BROADCAST — assigning one paints it onto every selected,
   *  still-editable row — which is wrong for exactly one caller: the post-commit reset, whose job
   *  is to empty the boxes, not to empty the rows the commit did not carry. Read by every setter
   *  that paints, so a new one is covered by following the same shape rather than by `resetHeader`
   *  remembering it exists. */
  private suppressHeaderPaint = false;

  /** The grid's rows. Assignments go through the setter so every row carries a `ROW_UID` before
   *  anything can read one — the array is replaced wholesale from six different places (the
   *  dataSource rebuild, `formatValue`, `applyPendingRestore`, `getValues`, `clonedRow`,
   *  `deletedRow`) and stamping at each of them is a rule the next one would forget. Rows are
   *  mutated in place everywhere else, which the getter allows untouched. */
  get copyProducts(): Product[] {
    return this.copyProductsValue;
  }

  set copyProducts(rows: Product[]) {
    this.copyProductsValue = rows ?? [];
    this.copyProductsValue.forEach(row => this.rowUid(row));
  }

  /** This row's stable identity, minting one if it has none yet.
   *
   *  Called from the template (`isRowSaving`) as well as from the save paths, so it must stay
   *  cheap and must not mutate a row that already has an id — every row reaching the template has
   *  been through the setter above, which leaves these calls pure reads. */
  rowUid(row: { [k: string]: any } | Product | undefined | null): string {
    if (!row) {
      return '';
    }
    const holder = row as { [k: string]: any };
    if (typeof holder[ROW_UID] !== 'string' || !holder[ROW_UID]) {
      holder[ROW_UID] = `r-${ROW_UID_LOAD_TOKEN}-${++rowUidCounter}`;
    }
    return holder[ROW_UID] as string;
  }

  /** Whether THIS row has a per-row save in flight — keyed on the row, never on its position.
   *  `deletedRow` on any row above it shifts every index below, so an index-keyed flag moved the
   *  spinner onto an unrelated row and handed the saving row its save button back: a second press
   *  POSTed the same movement again.
   *
   *  It reads `loadingType` and NOTHING ELSE, deliberately. This runs from the template on every
   *  rendered row and once per row of `copyProducts` inside `allsValid()` — a full pass per CD
   *  cycle — so the key concatenation is a real per-keystroke allocation on a large session, and
   *  an in-flight COUNTER short-circuiting it is the obvious optimisation. It was tried and
   *  reverted: a counter is a second source of truth for "is a save on the wire", and it desyncs
   *  from `loadingType` the moment anything writes that map without going through
   *  `saveDefinitive`. That is the same drift `saveDefinitive`'s own comment forbids for the flag
   *  itself, bought for an allocation. If this ever needs to be cheaper, make the KEY cheaper (a
   *  per-type map, so no string is built), not the truth more numerous. */
  isRowSaving(row: { [k: string]: any } | Product | undefined | null): boolean {
    return !!row && !!this.loadingType[this.rowUid(row) + TypeSaveInsert.SINGLE];
  }

  /** Whether a BULK commit is in flight. Gates a second Save-all (`setAll`); per-row saves gate
   *  on `isRowBulkLocked` instead, which scopes the lock to the rows the bulk actually carried. */
  isBulkSaving(): boolean {
    return !!this.loadingType[TypeSaveInsert.MULTIPLE];
  }

  /** Lowers the full-screen block a commit raised — but only when this commit is the one still
   *  holding it.
   *
   *  `LayoutActionType.LoadingBlock` is a plain boolean with no ref counting, and a per-row save
   *  completing DURING a bulk is a supported flow (`isRowBulkLocked` deliberately keeps per-row
   *  saves live for rows the bulk did not snapshot). Cleared blanket, that per-row success took the
   *  overlay down while the bulk POST was still on the wire, leaving the grid interactive over a
   *  batch mid-commit — and the bulk's own later clear was then a no-op. Same scoping the sibling
   *  `loadAll` / `bulkCommittedRows` clears already have, for the same reason.
   *
   *  A bulk always lowers its own block: it is still holding its `loadingType` flag at this point,
   *  so `isBulkSaving()` reads true for it too and the `type` clause is what lets it through. */
  private clearCommitBlock(type: TypeSaveInsert): void {
    if (type === TypeSaveInsert.MULTIPLE || !this.isBulkSaving()) {
      this.store.dispatch(new BaseAction(LayoutActionType.LoadingBlock, false));
    }
  }

  /** The ROW_UIDs the in-flight bulk snapshotted — the ONLY rows whose per-row save is locked
   *  while it runs. `null` with a bulk in flight means the bulk named no row set (a legacy
   *  "every row" caller), so every row is locked, conservatively. Written exclusively by
   *  `saveDefinitive`'s bulk path, in lockstep with the bulk `loadingType` flag; distinct on
   *  purpose from the `committedRows` PARAMETER the success path consumes (see that doc for why
   *  consuming from a shared field was a bug). */
  private bulkCommittedRows: ReadonlySet<string> | null = null;

  /** Whether THIS row's per-row save must be refused because an in-flight bulk already carries
   *  it: its values are only blanked when the bulk's success comes back, so it still LOOKS
   *  savable, and a press during the round trip would re-POST the same movement. Dropping such a
   *  press is correct — the work it asks for is already on the wire — but ONLY for rows the bulk
   *  snapshotted: a blanket lock on `isBulkSaving()` silently dropped presses on rows the bulk
   *  never carried (a row finished while 50 others crawl through a slow connection), the
   *  in-flight-flag-in-`[disabled]` anti-pattern. Rows outside the snapshot stay live; their save
   *  is independent work the wire has not seen. */
  isRowBulkLocked(row: { [k: string]: any } | Product | undefined | null): boolean {
    if (!row || !this.isBulkSaving()) {
      return false;
    }
    return this.bulkCommittedRows == null || this.bulkCommittedRows.has(this.rowUid(row));
  }
  private subs2 = new SubSink();
  private itemsToLoadOnSave: Product[] = [];
  private subs = new SubSink();
  private $displayedColumns!: string[] | undefined;
  private sortSubject: Subject<SortStatus> = new Subject<SortStatus>();
  readonly sort: Observable<SortStatus> = this.sortSubject.asObservable();
  private actions: { [key: string]: TableAction[] } = {};

  @Output()
  rowSelect = new EventEmitter<TableSelection>();

  @Output()
  status = new EventEmitter<TableStatus>(true);

  @Output()
  custom = new EventEmitter<TableEvent>();

  @Input()
  dataSource!: Observable<TableData>;

  @Input()
  getRowTable: boolean | undefined;

  @Input()
  config!: TableConfig | undefined;

  @Input()
  productStructureCond!: ProductStructure | undefined;

  @Input()
  dataExtra: { [k: string]: any[] } = {};

  @Input() filtersOff!: DynaCrudRequest;

  @ViewChild(CdkVirtualScrollViewport) viewport!: CdkVirtualScrollViewport;

  @ViewChild('inputSingle_') inputSingle_: any;

  @ViewChild('cdkConOverlay', { static: false }) overLayConected: CdkConnectedOverlay | undefined;


  private ownerCode = '';

  constructor(
    public store: Store<State>,
    public dialog: MatDialog,
    private dialogService: DialogService,
    private setInsertService: SetInsertService,
    private draftService: SetInsertDraftService,
    private activateRouter: ActivatedRoute,
    private sharedService: SharedService,
    private router: Router,
    private productStructureService: ProductStructureService,
    private translateService: TranslateService,
    private dynacrudApiWrapper: DynacrudApiWrapper,
    public host: ElementRef<HTMLElement>,
    private scrollToTop: ScrollToTopService) {
    this.ownerCode = captureOwnerCode(this.store);
  }

  @Input()
  set displayedColumns(displayedColumns: string[] | undefined) {
    this.$displayedColumns = displayedColumns;
  }

  get displayedColumns(): string[] | undefined {
    return this.$displayedColumns || this.config?.columnsFields?.map(value => value.id);
  }

  get validKey(): string {
    return this.validKeyValue;
  }

  set validKey(v: string) {
    this.validKeyValue = v;
  }

  @HostListener('document:click', ['$event']) clickedOutside() {
    this.isOpen = {};
    this.columnMenuOpen = false;
  }


  get commentsAll() {
    return this.comentsValue;
  }

  set commentsAll(v: string) {
    this.comentsValue = v;
    this.setKept(keepValueComment, this.comentsValue);
    if (this.suppressHeaderPaint) { return; }
    this.copyProducts.forEach((d, index) => {
      if (d && d.active && d.editable && d.editable[TypeEditTable.COMMENT]) {
        this.productGestione(index, false).productComment = this.comentsValue;
      }
    });
  }

  get quantityAll(): number | null | undefined {
    return this.quantityValue;
  }

  set quantityAll(v: number | null | undefined) {
    this.quantityValue = v;
    this.setKept(keepValueQuantity, this.quantityValue);
    if (this.suppressHeaderPaint) { return; }
    this.copyProducts.forEach((d, index) => {
      if (d && d.active && d.editable && d.editable[TypeEditTable.QUANTITY]) {
        this.productGestione(index, false).productQuantity = this.quantityValue;
      }
    });
  }



  get purchasePriceModel(): number | null | undefined {
    return this.purchasePriceValue;
  }

  set purchasePriceModel(v: number | null | undefined) {
    this.purchasePriceValue = v;
    this.setKept(keepValuePurchasePrice, this.purchasePriceValue);
    if (this.suppressHeaderPaint) { return; }
    this.copyProducts.forEach((d, index) => {
      if (d && d.active && d.editable && d.editable[TypeEditTable.PURCHASEPRICE]) {
        this.productGestione(index, false).productPurchasePrice = this.purchasePriceValue;
      }
    });
  }

  get productSelectAll(): boolean {
    return this.productSelectValueAll;
  }

  set productSelectAll(value: boolean) {

    this.productSelectValueAll = value;
    this.setKept(keepSelectAll, this.productSelectValueAll);

    this.loadStructureForSelectAll(value);

    /*if ( this.productSelectValueAll ) {

      const values = { ...this.valueFiledAll };

      if ((values != undefined) && !isEmptyObject(values)) {

        me.copyProducts?.map((val: { [k: string]: any }, i) => {

          this.productSelectValue[i] = v;

          val['active'] = v;

          if (val['editable']['COMMENT']) {
            val['comment'] = this.comentsValue;
          }

          if (val['editable']['WAREHOUSES']) {
            val['warehouseRow'] = this.entityAll;
          }

          if (val['editable']['QUANTITY']) {
            val['quantity'] = this.quantityValue;
          }

          if (val['editable']['PURCHASEPRICE']) {
            val['purchasePrice'] = this.purchasePriceValue;
          }

          if (val['editable']['LANGUAGE'] && this.valueFiledAll['languageRow'] != undefined) {
            val['languageRow'] = val['languages']?.find((v: Language) => v.id == this.valueFiledAll['languageRow']);
          }

          if (val['editable']['HOLOS'] && this.valueFiledAll['holoRow'] != undefined) {
            val['holoRow'] = val['holos']?.find((v: Holo) => v.id == this.valueFiledAll['holoRow']);
          }

          if (val['editable']['CONDITION'] && this.valueFiledAll['conditionRow'] != undefined) {
            val['conditionRow'] = val['conditions']?.find((v: Condition) => v.id == this.valueFiledAll['conditionRow']);
          }

          return val;
        });

      } else {

        Object.keys(values).forEach(d => {
          const value = this.valueFiledAll[d];

          me.copyProducts?.map((val: { [k: string]: any }, i ) => {

            this.productSelectValue[i] = v;

            val['active'] = v;

            if ((d != 'languageRow' && d != 'conditionRow') && val['editable'][d]) {
              val[d] = value;
            }

            // fixme current
            if (val['editable']['COMMENT']) {
              val['comment'] = this.comentsValue;
            }

            if (val['editable']['WAREHOUSES']) {
              val['warehouseRow'] = this.entityAll;
            }

            if (val['editable']['QUANTITY']) {
              val['quantity'] = this.quantityValue;
            }

            if (val['editable']['PURCHASEPRICE']) {
              val['purchasePrice'] = this.purchasePriceValue;
            }

            if (val['editable']['LANGUAGE'] && this.valueFiledAll['languageRow'] != undefined) {
              val['languageRow'] = val['languages']?.find((v: Language) => v.id == this.valueFiledAll['languageRow']);
            }

            if (val['editable']['HOLOS'] && this.valueFiledAll['holoRow'] != undefined) {
              val['holoRow'] = val['holos']?.find((v: Holo) => v.id == this.valueFiledAll['holoRow']);
            }

            if (val['editable']['CONDITION'] && this.valueFiledAll['conditionRow'] != undefined) {
              val['conditionRow'] = val['conditions']?.find((v: Condition) => v.id == this.valueFiledAll['conditionRow']);
            }

            return val;
          });
        });
      }

    } else {
      this.copyProducts.map((pr, i) => { this.productSelectValue[i] = false; pr.active = false; return pr; });
    }*/
  }

  private loadStructureForSelectAll (v: boolean) {
    const me = this;

    if ( this.productSelectValueAll ) {

      const values = { ...this.valueFiledAll };

      if ( (values == undefined) || isEmptyObject(values) ) {

        me.copyProducts?.map((val: { [k: string]: any }, i) => {

          this.productSelectValue[i] = v;

          val['active'] = v;

          if (val['editable']['COMMENT']) {
            val['comment'] = this.comentsValue;
          }

          if (val['editable']['WAREHOUSES']) {
            val['warehouseRow'] = this.entityAll;
          }

          // `?? undefined`: the header fields are nullable (the number directive emits null for an
          // emptied box) while the ROW model is `number | undefined` — the same normalisation the
          // productQuantity/productPurchasePrice setters do, repeated here because this path paints
          // copyProducts directly instead of going through them.
          if (val['editable']['QUANTITY']) {
            val['quantity'] = this.quantityValue ?? undefined;
          }

          if (val['editable']['PURCHASEPRICE']) {
            val['purchasePrice'] = this.purchasePriceValue ?? undefined;
          }

          if (val['editable']['LANGUAGE'] && this.valueFiledAll['languageRow'] != undefined) {
            val['languageRow'] = val['languages']?.find((v: Language) => v.id == this.valueFiledAll['languageRow']);
          }

          if (val['editable']['HOLOS'] && this.valueFiledAll['holoRow'] != undefined) {
            val['holoRow'] = val['holos']?.find((v: Holo) => v.id == this.valueFiledAll['holoRow']);
          }

          if (val['editable']['CONDITION'] && this.valueFiledAll['conditionRow'] != undefined) {
            val['conditionRow'] = val['conditions']?.find((v: Condition) => v.id == this.valueFiledAll['conditionRow']);
          }

          return val;
        });

      } else {

        Object.keys(values).forEach(d => {
          const value = this.valueFiledAll[d];

          me.copyProducts?.map((val: { [k: string]: any }, i ) => {

            this.productSelectValue[i] = v;

            val['active'] = v;

            if ((d != 'languageRow' && d != 'conditionRow') && val['editable'][d]) {
              val[d] = value;
            }

            // fixme current
            if (val['editable']['COMMENT']) {
              val['comment'] = this.comentsValue;
            }

            if (val['editable']['WAREHOUSES']) {
              val['warehouseRow'] = this.entityAll;
            }

            // Normalised for the same reason as the branch above.
            if (val['editable']['QUANTITY']) {
              val['quantity'] = this.quantityValue ?? undefined;
            }

            if (val['editable']['PURCHASEPRICE']) {
              val['purchasePrice'] = this.purchasePriceValue ?? undefined;
            }

            if (val['editable']['LANGUAGE'] && this.valueFiledAll['languageRow'] != undefined) {
              val['languageRow'] = val['languages']?.find((v: Language) => v.id == this.valueFiledAll['languageRow']);
            }

            if (val['editable']['HOLOS'] && this.valueFiledAll['holoRow'] != undefined) {
              val['holoRow'] = val['holos']?.find((v: Holo) => v.id == this.valueFiledAll['holoRow']);
            }

            if (val['editable']['CONDITION'] && this.valueFiledAll['conditionRow'] != undefined) {
              val['conditionRow'] = val['conditions']?.find((v: Condition) => v.id == this.valueFiledAll['conditionRow']);
            }

            return val;
          });
        });
      }

    } else {
      this.copyProducts.map((pr, i) => { this.productSelectValue[i] = false; pr.active = false; return pr; });
    }

  }

  /** The MODEL-level belt: nothing unsendable may reach the POST whatever route produced it.
   *  Which rows are OFFERED for saving is `canSaveRow`'s answer, on the row — `setAll` gates on
   *  that first and only then maps to models, so the button, the counter and the bulk agree by
   *  construction rather than by two predicates being kept in step by hand. The draft path does
   *  NOT come through here at all: `getValid` admits on the ROW (`hasRowInput || canSaveRow`) and
   *  maps straight to models, deliberately, since the draft may never be narrower than what a save
   *  carries. */
  filterFN(item: WarehouseMovementDTORequiredPrev): boolean {

    // A row is addressable either by an explicit destination warehouse or by an allocation
    // strategy — the backend needs exactly one of them.
    const hasDestination = !!item['warehouseToId'] || !!item['strategy'];

    // Finite, not just non-nullish: `NaN != undefined` is true, so a NaN quantity used to pass
    // this gate, survive setAll's `_.omitBy(_.isNil)` and go out as `"quantity":null` (that is
    // what JSON.stringify does with NaN) — failing the whole bulk POST with
    // `error.session.execution_errors`. The restore that produced the NaN is fixed at the source
    // (keptNumber); this is the belt that keeps any other route to a NaN off the wire. Coercing
    // rather than testing the number type keeps a legitimate "3" sendable — getModel stores the
    // COERCED number, so accepting the string here cannot put a quoted quantity on the wire.
    const hasQuantity = isUsableQuantity(item['quantity']);

    // No `brandId` clause, and no brand-6 special case. Both used to be here and neither ever
    // decided anything: `getModel` always emits `holoId` (falling back to `null`), so the brand-6
    // test `holoId !== undefined` was true for every row, while the `else if (brandId != undefined)`
    // meant a row whose product carries no brand fell through to `return false` and was dropped
    // from the bulk with no error anywhere — even though `brandId` is `_.omit`ted from the payload
    // and the wire never sees it. The per-row path (which does not run filterFN) saved such a row
    // happily, so the two paths disagreed about a row the backend accepts either way.
    //
    // What brand 6 really needs is a CHOSEN holo, which only the row knows (the model's `holoId`
    // cannot tell "not picked" from "no holos offered"). That test lives in `canSaveRow`, which
    // both save paths gate on first, so this belt stays what it says it is: the wire-level check
    // that nothing unsendable goes out.
    return !!(item && hasQuantity && item['conditionId'] && item['languageId'] && hasDestination);
  }

  /** True when a row's warehouse must be treated as Auto: either the row itself carries the
   *  sentinel, OR the current user's role forces it regardless of what the row's warehouseRow
   *  actually holds. The second half is what keeps a forced user's payload safe even when
   *  warehouseRow was populated behind the setters' backs - a restored draft (applyPendingRestore)
   *  paints copyProducts directly, and a kept ("keep value") header restore goes through
   *  entityValueAll, neither of which is itself autoForced-aware. Making THIS the single place
   *  that resolves "does this row use Auto" - not the option list, not the setters - means every
   *  route into warehouseRow is covered without having to guard each one individually. */
  private resolvesToAuto(row: { id?: number | string } | null | undefined): boolean {
    return this.autoForced || isAutoWarehouse(row);
  }

  getModel(value: { [k: string]: any }, isLoad: boolean): WarehouseMovementDTORequiredPrev {
    const otherEdit : {[k: string] : any} = { ...value['editable'] }  || {};

    // esto debe controlar los elementos que vienen agregados desde el header, para deshabilitarlos
    // Object.keys( value['editable'] ).forEach(v => {
    //   otherEdit[v] = false;
    // });

    // The movement fields BOTH shapes carry, built once. The two return literals used to repeat
    // every one of these expressions verbatim, so a payload-level guard (the quantity coercion
    // below was the live case) had to be written twice — and the first one applied to only one
    // branch reintroduces the class of bug on the path that was missed. The load shape spreads
    // these and adds its display/restore extras on top.
    const movementFields = {
      brandId: value['brandId'],
      altered: value['altered'] != undefined ? value['altered'] : null,
      comment: value['comment'] != undefined ? value['comment'] : null,
      conditionId: value['conditionRow'] != undefined && value['conditionRow'].id != undefined ? value['conditionRow'].id : null,
      firstEdition: value['firstEdition'] != undefined ? value['firstEdition'] : null,
      foil: value['foil'] != undefined ? value['foil'] : null,
      holoId: value['holoRow'] != undefined && value['holoRow'].id != undefined ? value['holoRow'].id : null,
      inked: value['inked'] != undefined ? value['inked'] : null,
      languageId: value['languageRow'] != undefined && value['languageRow'].id ? value['languageRow'].id : null,
      productId: value['id'] != undefined ? value['id'] : null,
      // Coerced, not copied: `isUsableQuantity` accepts a numeric STRING (a restored draft, a
      // backend payload that serializes it that way) and `isUnsendable('3')` is false, so an
      // uncoerced copy goes out as `"quantity":"3"` against a numeric backend field. Anything
      // the predicate refuses (NaN, 0, a non-numeric string) becomes null and is dropped by
      // filterFN / omitBy exactly as before.
      quantity: coerceQuantity(value['quantity']) ?? null,
      // Coerced for the same reason as quantity, one line up: a string price travels the same
      // restore/copy/serialize route and a verbatim copy would go out quoted.
      purchasePrice: coercePurchasePrice(value['purchasePrice']) ?? null,
      shadowless: value['shadowless'] != undefined ? value['shadowless'] : null,
      signed: value['signed'] != undefined ? value['signed'] : null,
      staff: value['staff'] != undefined ? value['staff'] : null,
      stamped: value['stamped'] != undefined ? value['stamped'] : null,
      warehouseToId: this.resolvesToAuto(value['warehouseRow']) ? null
        : (value['warehouseRow'] != undefined && value['warehouseRow'].id != undefined ? value['warehouseRow'].id : null),
      strategy: this.resolvesToAuto(value['warehouseRow']) ? AUTO_STRATEGY : undefined,
    };

    if (isLoad) {

      if (value['editable'] != undefined) {

        // The load shape must mark every stored value's cell OWNED (`editable[col] = false`) —
        // `hasRowInput` is what re-admits a restored row into later drafts, and a header apply
        // skips owned cells. Owned-ness is derived from the STORED VALUE each column actually
        // answers to, mapped explicitly: the old name-guessing (`value[col.toLowerCase()]`, then
        // `+ 'Row'`) never matched `purchasePrice` ('PURCHASEPRICE'.toLowerCase() is
        // 'purchaseprice'), so a price-only row restored as owning NOTHING — silently dropped
        // from every later draft write, its price overwritable from the header — and it matched
        // the `warehouses`/`holos` LOOKUP ARRAYS, claiming ownership of cells the operator never
        // touched the moment the lookups were stamped. The default arm keeps the old value/name
        // heuristic for the structure flag fields (`foil`, `signed`, ...), whose editable key IS
        // their value property.
        const storedValue = (column: string): unknown => {
          switch (column) {
            case TypeEditTable.QUANTITY: return value['quantity'];
            case TypeEditTable.PURCHASEPRICE: return value['purchasePrice'];
            case TypeEditTable.COMMENT: return value['comment'];
            case TypeEditTable.LANGUAGE: return value['languageRow'];
            case TypeEditTable.CONDITION: return value['conditionRow'];
            case TypeEditTable.HOLOS: return value['holoRow'];
            case TypeEditTable.WAREHOUSES: return value['warehouseRow'];
            default: return value[column.toLowerCase()] != null ? value[column.toLowerCase()] : value[column];
          }
        };
        Object.keys(value['editable']).forEach(column => {
          otherEdit[column] = storedValue(column) == null;
        });

      }

      return {
        // active: value['active'],
        // languages: value['languages'],
        // conditions: value['conditions'],
        // warehouses: value['warehouses'],
        // holos: value['holos'],
        ...movementFields,
        // The DRAFT keeps the RAW stored values, overriding the coerced pair in `movementFields`.
        // The coercions protect the WIRE (the non-load shape filterFN/omitBy consume); applied to
        // the draft they silently REWROTE the very values the save gates hold the row on screen
        // for the operator to correct — a negative price (`isNegativePurchasePrice` blocks the
        // row "until the cell is corrected") persisted as `null`, so one autosave tick plus a
        // reload produced a blank, freely-savable price box and the movement booked with no cost:
        // the exact outcome the guard exists to prevent, re-introduced through the draft. A
        // restored raw value re-enters the commit path through `getModel(value, false)`, where
        // the coercions still apply.
        quantity: value['quantity'] != undefined ? value['quantity'] : null,
        purchasePrice: value['purchasePrice'] != undefined ? value['purchasePrice'] : null,
        brand: value['brand'],
        category: value['category'],
        categoryId: value['categoryId'],
        name: value['name'],
        cardData: value['cardData'],
        expansion: value['expansion'],
        color: value['color'],
        rarity: value['rarity'],
        productStructureId: value['productStructureId'],
        number: value['number'],
        id: value['id'],
        editable: otherEdit,
        languageRow: value['languageRow'],
        conditionRow: value['conditionRow'],
        warehouseRow: value['warehouseRow'],
        holoRow: value['holoRow'],



      };
    }
    return movementFields;


  }


  setAll() {
    // A second Save-all while the first is still on the wire would snapshot the same rows again —
    // their values are only blanked when the first bulk's success comes back — and book every
    // movement twice.
    if (this.isBulkSaving()) {
      return;
    }

    // Gate on the ROW with canSaveRow — the same predicate the button and the counter use — and
    // remember WHICH rows made it. filterFN still runs on the model afterwards as the wire belt
    // (nothing non-finite may reach the POST whatever route produced it), but a row it drops
    // must not be treated as committed: `reset()` blanks every row it is given, so a row that
    // was silently skipped used to have the operator's values wiped by the success toast of a
    // save it was never part of, with the draft deleted in the same breath.
    //
    // The rows are remembered by ROW_UID, never by index and never by object reference. `reset()`
    // consumes the set after the POST round-trip, and by then the array may have been spliced
    // (`clonedRow`/`deletedRow`) or replaced wholesale by fresh deep clones (either of those, or
    // `getValues` attaching the lookup arrays): an index resolves to a DIFFERENT row and a
    // reference to none at all — blanking a row the commit never carried, or leaving a committed
    // one filled for the next Save all to re-send as a duplicate movement. The uid survives every
    // clone; a row genuinely replaced by new data is simply not matched, which leaves values on
    // screen rather than destroying them.
    //
    // Read straight off `copyProducts`: neither `getModel` nor `canSaveRow` mutates its argument,
    // and the deep clone this used to take copied every row's attached lookup arrays
    // (`languages`/`conditions`/`holos`/`warehouses`, stamped onto each row by `getValues`) —
    // megabytes of structured clone on the main thread on a large session, before the POST is
    // even built.
    //
    // Rows are gated FIRST, models built only for the survivors: `getModel` is a ~20-field build
    // per row, and on a large session page most rows are untouched search results `canSaveRow`
    // rejects without ever needing a model (same shape as `getValid`).
    const committed = new Set<string>();
    const productsToPushCopy = (this.copyProducts as any[])
      // `!isRowSaving`: a row whose own per-row POST is on the wire is not blanked yet (reset()
      // runs on its success), so without this clause the bulk snapshots the same movement a
      // second time and the backend books it twice — one press, one Save all, duplicate stock.
      .filter((row: { [k: string]: any }) => this.canSaveRow(row) && !this.isRowSaving(row))
      .map((row: { [k: string]: any }) => ({ row, model: this.getModel(row, false) }))
      .filter(({ row, model }) => {
        const sendable = this.filterFN(model);
        if (sendable) { committed.add(this.rowUid(row)); }
        return sendable;
      })
      .map(({ model }) => _.omitBy({ ..._.omit({ ...model }, 'brandId') }, isUnsendable));

    // Everything the button counted can have dropped out between the press and this snapshot.
    // `allsValid` now counts with this very gate (`canSaveRow && !isRowSaving`), so no in-tree
    // path offers a press that is KNOWN to snapshot empty any more — this is the belt for the
    // residual race (a row's state changing between the count's CD cycle and the click landing).
    // POSTing the empty array anyway books nothing but still reports success, rewrites the draft
    // for a commit that carried zero rows — and on a FIRST save the success handler dereferences
    // `d[0].warehouseSession` on an empty response and throws inside the subscribe. Nothing to
    // send means nothing to do.
    if (productsToPushCopy.length === 0) {
      // Said, not swallowed. The press is reachable (the race the paragraph above names), and
      // refusing it in silence — no spinner, no request, no message — is the dropped-press shape
      // this component closes everywhere else: the button looks pressed and nothing at all happens,
      // which invites the same press again. A short toast is the whole fix; there is nothing for
      // the operator to do but look at the rows.
      this.dialogService.openSnack('common.message.nothingToSave', { icon: 'info' });
      return;
    }

    this.loadAll = true;
    this.saveDefinitive(undefined, productsToPushCopy, TypeSaveInsert.MULTIPLE, committed);

  }

  /** Clears the header controls after a commit — WITHOUT broadcasting the cleared values onto the
   *  rows those controls apply to.
   *
   *  Every assignment below goes through a header setter, and every header setter paints its new
   *  value onto each selected, still-editable row. So this method used to undo the whole point of
   *  the scoped `reset()` it is called one line after: `quantityAll = undefined` blanked the
   *  quantity of every selected row, `commentsAll = ''` their comment and `productFieldAll =
   *  undefined` their language/condition/holo — including the rows the commit had SKIPPED, which
   *  are exactly the rows with no other copy. `settleDraftAfterCommit()` then rebuilt the draft
   *  from the already-blanked rows and deleted it, with the restore picker suppressed on top.
   *
   *  The committed rows need no repaint either: `reset()` has just blanked them. */
  private resetHeader() {
    if (!this.persistValueOn) {
      this.suppressHeaderPaint = true;
      try {


        if (this.productStructure && this.productStructure.stockfields && this.productStructure.stockfields.length > 0) {

          this.productStructure.stockfields.forEach(field => {
            if (field.type == 'LOOKUP') {
              this.productGestioneFieldsAll(field.field + 'Row').productFieldAll = undefined;
              this.valueFiledAll[field.field + 'Row'] = undefined;
              // this.valueFiledAll['languageRow'] = undefined;

            }

            if (field.type == 'FLAG') {

              this.valueFiledAll[field.field as string] = undefined;
              // Same reason as the warehouse below: this branch assigns the backing map directly,
              // so it reaches no setter and no `setKept`. `setValueFieldAll` writes the flag's kept
              // key on EVERY header toggle, keep-values on or off, so without this the discarded
              // batch's `foil`/`signed`/… survived a "keep values off" commit — switch keep-values
              // back ON and `loadHeaderValues` read `'true'` back and painted it onto every
              // selected editable row, booking movements as foil nobody set.
              this.removeKept(keepValue + field.field);
            }
          });

        }


        this.commentsAll = '';
        // The comment's setter DOES reach `setKept` — but with `''`, and `isUnsendable('')` is
        // false (it tests for nil and non-finite numbers, not for emptiness), so the setter writes
        // an empty value rather than removing the key. Harmless to read back (`keptString(...) ??
        // ''` lands on the same empty comment either way), which is why it went unnoticed, but it
        // leaves a key in BOTH storage areas after a commit that was supposed to keep nothing —
        // in the quota the storage probe exists to protect. Removed explicitly, like the three
        // below, rather than by widening `isUnsendable`: that predicate is the wire's rule, shared
        // with both save paths, and an empty string is a perfectly sendable comment.
        this.removeKept(keepValueComment);
        this.entityAll = undefined;
        // Assigning the backing field (above) is deliberate — the `entityValueAll` setter also
        // raises `errorCustomAll` and arms a deferred writeValue for an unresolvable id, which is
        // not what a clear means. The rule this method lives by: a field cleared through its
        // SETTER drops its kept storage key on the way (`setKept` removes the key for a value with
        // nothing to remember — the quantity, the price and the three LOOKUPs all clear to
        // `undefined` and are in that group), and a field cleared by assigning its backing field —
        // or cleared through a setter to a value `setKept` still considers worth remembering, as
        // the comment above is — must remove the key ITSELF. The comment, the warehouse, the FLAGs
        // above and select-all below are the four in that second group, and each was found the
        // same way: the discarded batch's value outlived a "keep values off" commit, and switching
        // keep-values back ON had `loadHeaderValues` restore it and paint it onto every selected
        // editable row. Removing the key explicitly is what "keep values off" means for them too.
        this.removeKept(keepValueWarehouse);
        this.quantityAll = undefined;
        // The price is header tooling exactly like the quantity beside it, and was the one field
        // this list forgot: it survived the commit, stayed in the header box, and the NEXT
        // select-all painted the previous batch's price onto every editable row
        // (`loadStructureForSelectAll` reads `purchasePriceValue` directly), so movements the
        // operator priced differently booked at the old figure. Clearing through the setter also
        // drops its kept storage key, which is what "keep values off" means.
        this.purchasePriceModel = undefined;
        // The backing field, not the `productSelectValue` setter — that setter re-runs
        // `loadStructureForSelectAll`, which is a paint. So it reaches no `setKept` either, and
        // `kept.keepSelectAll` outlived the commit: the next keep-values-on load restored
        // select-all and, with it, every kept header value onto rows the operator never selected
        // (`loadHeaderValues` gates each restore on `d.active`). Removed rather than written as
        // 'false' — nothing kept is exactly what "keep values off" means, and it leaves no key
        // sitting in the quota.
        this.productSelectValueAll = false;
        this.removeKept(keepSelectAll);
      } finally {
        // `finally`, so a throw from any setter above cannot leave the flag up: every later
        // apply-from-header in the page's life would silently stop reaching the rows.
        this.suppressHeaderPaint = false;
      }

    }


    setTimeout(() => {

      this.resetValueOnFireSubject.next(false);
    }, 2000);


  }


  /** The half of the search-reload header clear that belongs to the PRODUCT STRUCTURE — the LOOKUP
   *  and FLAG fields the structure itself declares, plus select-all.
   *
   *  Split out because it is the only half a structure-changing search may clear while "keep
   *  values" is on: a `language`/`condition`/`holo` id and a `foil`/`signed` flag are scoped to the
   *  structure that declared them and mean nothing under the next one, whereas a comment, a
   *  quantity, a destination warehouse and a purchase price are the operator's own values and are
   *  exactly what keep-values promises to carry across a search.
   *
   *  Select-all belongs here, not with the generic values: the structure branch deselects every row
   *  (`d.active = false`), so leaving the toggle — or its kept key — up would claim a selection
   *  that no longer exists, and `loadHeaderValues` gates each restore on `d.active`. */
  private clearStructureScopedHeaderTooling(): void {
    if (this.productStructure && this.productStructure.stockfields && this.productStructure.stockfields.length > 0) {
      this.productStructure.stockfields.forEach(field => {
        if (field.type == 'LOOKUP') {
          this.productGestioneFieldsAll(field.field + 'Row').productFieldAll = undefined;
        }
        if (field.type == 'FLAG') {
          this.valueFiledAll[field.field as string] = undefined;
          this.removeKept(keepValue + field.field);
        }
      });
    }

    this.productSelectValueAll = false;
    this.removeKept(keepSelectAll);
  }

  /** The FULL header clear a "keep values off" search-reload runs.
   *
   *  One method because it was two byte-identical copies that had already drifted from the commit
   *  path's `resetHeader()`: neither cleared the purchase price (so the previous batch's figure
   *  survived the reload and the next select-all painted it onto every editable row —
   *  `loadStructureForSelectAll` reads `purchasePriceValue` directly), and neither dropped the
   *  KEPT warehouse, FLAG or select-all keys, since each of those clears assigns a backing field
   *  and reaches no `setKept` (see `resetHeader` for the full rule). A third copy is how a fourth
   *  field gets forgotten.
   *
   *  Every clear here removes its kept key as well as its on-screen value, and the two must stay in
   *  step in BOTH directions: a value cleared on screen whose key survives comes back on the next
   *  mount (`loadHeaderValues`) and is painted onto rows the operator never gave it to, and a key
   *  removed under a value still showing loses it silently at the same moment. That is why the
   *  structure branch calls `clearStructureScopedHeaderTooling()` rather than this method when
   *  keep-values is on — it clears less, so it must also forget less.
   *
   *  Deliberately NOT `resetHeader()` itself: that one wraps the clear in `suppressHeaderPaint` and
   *  arms the `resetValueOnFireSubject` timer, both of which belong to the post-commit path. Here
   *  the rows are about to be rebuilt from the incoming page anyway, and the comment/quantity
   *  setters have always painted on this path. The direct `entityAll` assignment stays for the
   *  reason it does in `resetHeader`: the `entityValueAll` setter also raises `errorCustomAll` and
   *  arms a deferred `writeValue`, which is not what a clear means. */
  private clearHeaderTooling(): void {
    this.clearStructureScopedHeaderTooling();

    this.commentsAll = '';
    // `setKept(keepValueComment, '')` writes rather than removes — see `resetHeader` for why.
    this.removeKept(keepValueComment);
    this.entityAll = undefined;
    this.removeKept(keepValueWarehouse);
    this.quantityAll = undefined;
    this.purchasePriceModel = undefined;
  }

  /**
   * The accessible name (and tooltip) for a FLAG icon -- foil, signed, first edition, whatever
   * else the backend's product structure declares.
   *
   * Both FLAG icons used to bind `[alt]="field"`, and `field` is a ProductStructureField: Angular
   * stringifies it, so the header's select-all icon and every row's toggle announced
   * "[object Object]". They are icon-only controls with no visible label, so the name is the only
   * thing that says which flag is being toggled.
   *
   * The vocabulary is data, not a fixed list, so a hardcoded key per flag cannot cover it. We ask
   * for `common.<flag>` and fall back to the raw field name when there is no such key -- ngx-
   * translate ECHOES a missing key, so without the echo test an unmapped flag would announce
   * `common.playset` rather than `playset`. Memoized per language because this is called from the
   * template, once per flag per row per change-detection pass, on a grid that renders hundreds.
   */
  flagLabel(ff: ProductStructureField | undefined): string {
    const name = ff?.field ?? '';
    if (!name) {
      return '';
    }
    const cacheKey = `${this.translateService.currentLang}|${name}`;
    const cached = this.flagLabels.get(cacheKey);
    if (cached !== undefined) {
      return cached;
    }
    const key = `common.${name}`;
    const translated = this.translateService.instant(key);
    const label = typeof translated === 'string' && translated !== key ? translated : name;
    this.flagLabels.set(cacheKey, label);
    return label;
  }

  /** Keyed by `<lang>|<flag>`, so a language switch does not serve the previous language's label. */
  private flagLabels = new Map<string, string>();

  getImagePath(ff: ProductStructureField): string | null {
    if (ff.field == 'signed' || ff.field == 'firstEdition') {
      return `assets/img/structure/${ff.field}.png`;
    }
    return `assets/img/structure/${ff.field}.svg`;

  }

  setValueFieldAll(field: ProductStructureField) {

    this.valueFiledAll[field.field as string] = !this.valueFiledAll[field.field as string];

    this.setKept(keepValue + field.field, this.valueFiledAll[field.field as string]);

    // The flag header is a painter like every other header setter, so it owes the same guard. It
    // is the one that was missing it, and only `resetHeader` clearing FLAG fields by direct
    // assignment (rather than through here) kept that from mattering — i.e. the invariant
    // `suppressHeaderPaint` documents was already false. Routed through here, a post-commit clear
    // would repaint the cleared flag onto the rows the commit SKIPPED, which is exactly the loss
    // the flag was introduced to stop.
    if (this.suppressHeaderPaint) { return; }

    this.copyProducts.forEach((d) => {
      if (field.field && d && d.active && (d.editable as { [key: string]: any })[field.field]) {
        (d as { [k: string]: any })[field.field as string] = this.valueFiledAll[field.field as string];
      }
    });

  }

  noImage(item: Product) {
    item.cardData.image = environment.defaultImageMagic;
  }


  setValueField(ff: ProductStructureField, indexProduct: number) {

    (this.copyProducts[indexProduct].editable as { [key: string]: boolean })[ff.field as string] = false;

    (this.copyProducts[indexProduct] as {
      [k: string]: any
    })[ff.field as string] = !(this.copyProducts[indexProduct] as { [k: string]: any })[ff.field as string];


  }


  getValues(values: any[], sourceField?: ProductStructureField) {
    if (values) {
      // The "some lists failed to load" latch is NOT cleared here. A retry still gets its toast —
      // it reloads the data, and `loadStructure` clears the latch as the round starts (see there) —
      // while a sibling lookup succeeding mid-round no longer un-silences the round that is still
      // failing.
      //
      // Attributed by the EMITTING FIELD when the template hands it over (it always does — see the
      // (getValues)="getValues($event, field)" binding), by sentinel content only as the fallback
      // for a caller that has nothing else. The sentinel test was the original attribution and it
      // reads list CONTENT as identity: a holo lookup whose permitted values exclude the entry
      // named exactly 'Regular' produced a non-empty list the sentinel could not claim, so
      // `el.holos` was never stamped, `canSaveRow`'s loaded-empty escape could not fire (unknown
      // means required) and every brand-6 row was unsavable by every path with no message — the
      // same silent dead-end the empty-emission branch below was added to close, reached through a
      // renamed lookup row instead of an empty one.
      const emitted = (name: string, sentinel: string): any[] => {
        if (sourceField?.field !== undefined) {
          return sourceField.field === name ? values : [];
        }
        return values.find(d => d?.name == sentinel)?.id != undefined ? values : [];
      };
      const languages = emitted('language', 'Inglese');
      const conditions = emitted('condition', 'Mint');
      const holo = emitted('holo', 'Regular');

      // The holo answer for this round has landed — see `holoAnswerSettled`. Attributed the same
      // way the stamps are: by the EMITTING FIELD when the template hands it over, and by content
      // only as the fallback, where an EMPTY emission carries nothing to attribute by and so
      // cannot settle anything.
      if (sourceField?.field === 'holo' || (holo && holo.length > 0)) {
        this.holoAnswerSettled = true;
      }

      if (languages && languages.length > 0) {
        this.copyProducts = _.cloneDeep(this.copyProducts.map(el => {
          el.languages = languages;
          return el;
        }));
      }

      if (conditions && conditions.length > 0) {
        this.copyProducts = _.cloneDeep(this.copyProducts.map(el => {
          el.conditions = conditions;
          return el;
        }));
      }

      if (holo && holo.length > 0) {
        this.copyProducts = _.cloneDeep(this.copyProducts.map(el => {
          el.holos = holo;
          return el;
        }));
      }

      // An EMPTY holo emission is stamped as an empty list — attribution needs `sourceField`, since
      // an empty array carries no content to attribute by. `canSaveRow` reads a LOADED empty
      // `holos` as "this product offers no holos" and drops the brand-6 holo requirement: a
      // brand-6 product whose lookup genuinely offers no holos was otherwise unsavable by EVERY
      // path, with no message anywhere (the old bulk path committed exactly that row). "This
      // product offers no holos" is knowledge, and only a LOADED empty list may claim it — which
      // this is: the child emits its search response as-is. Languages/conditions are left alone:
      // nothing reads a loaded-empty claim for them, and their row cells stay gated off either way.
      //
      // Stamped ONLY onto rows whose own category/brand resolve to the STRUCTURE the header lookup
      // answered for (`this.productStructure`, resolved from the first qualifying row). The lookup
      // knows nothing about any other structure, and a search can return rows of mixed
      // category/brand: stamping grid-wide waived the brand-6 holo requirement for rows of a
      // DIFFERENT structure whose products do offer holos — `holosKnownEmpty` went true, the holo
      // cell disappeared (`*ngIf` on a non-empty list), and the movement booked with `holoId`
      // omitted: the exact silent no-variant booking this branch exists to close, reopened for
      // mixed grids. A row whose structure cannot be resolved, or does not match, keeps `holos`
      // unknown — and unknown means required. The non-empty stamps above are deliberately left
      // grid-wide: a foreign non-empty list can only ADD the requirement, never waive it.
      //
      // The clone is taken ONLY when a row actually needs the stamp. This branch is re-entered on
      // every `sharedService.nextReloadData` tick (the lookup child re-emits its list on each one),
      // so an unconditional `_.cloneDeep` of the whole grid was a full structured clone of every
      // row, on the main thread, per tick, to re-apply a stamp that was already there.
      if (sourceField?.field === 'holo' && values.length === 0 && this.needsEmptyHoloStamp(this.copyProducts)) {
        const next = _.cloneDeep(this.copyProducts);
        this.stampLoadedEmptyHolos(next);
        this.copyProducts = next;
      }

      // The lookup arrays (languages/conditions/holos) have just been attached. If keep-values
      // is on with select-all active, re-apply the kept header values so the language/condition/
      // holo lookups land on the selected rows (they couldn't be applied during the data rebuild,
      // when these arrays didn't exist yet). Deferred to the next tick because this runs from a
      // child @Output during change detection; mutating the rows synchronously here flips the
      // template's allsValid()/allsValidValue and triggers NG0100 (ExpressionChangedAfterChecked).
      if (this.persistValueOn && this.productSelectValueAll) {
        setTimeout(() => this.loadStructureForSelectAll(true), 0);
      }

      setTimeout(() => {
        this.loadingAll = true;
      }, 0);
    }

  }

  /** A header lookup's search FAILED, so its list will never arrive and every row stays gated on
   *  it (`canSaveRow` reads an unknown list as required; the row template's *ngIf keeps the cells
   *  hidden). Fail-closed is right — fabricating an empty list would WAIVE the brand-6 holo
   *  requirement and book a movement with no variant — but it must not also be SILENT: without
   *  this the operator's fully-filled rows simply never became savable for the rest of the mount,
   *  with nothing on screen and nothing in the console. Same message, and the same way out (a new
   *  search reloads the lookups), that the restore path already gives.
   *
   *  Latched per SEARCH ROUND — cleared by `loadStructure`, which rebuilds the header lookups and
   *  is therefore the only moment new failures become possible. The three fail together whenever
   *  the backend is down, and three stacked toasts say nothing the first one didn't; a round where
   *  one of them happens to answer is still one round. `sticky` — it stays until dismissed, because
   *  this is the only explanation the operator will get, and behind a per-round latch a toast that
   *  auto-dismisses while the operator looks away says nothing at all for the rest of the round.
   *  (Omitting `time` does NOT do this: `openSnack` defaults to 4000ms.) */
  private headerLookupFailureReported = false;

  headerLookupLoadFailed(field?: ProductStructureField): void {
    // A failed holo lookup is an answer of a kind: the list will never arrive this round, so a
    // brand-6 row still carrying no `holos` array is genuinely stuck rather than mid-load, and the
    // per-row warning may now name it. Attributed — a failing LANGUAGE lookup says nothing about a
    // holo list still in flight, and settling on it would restore the false alarm.
    if (field?.field === 'holo') {
      this.holoAnswerSettled = true;
    }
    if (this.headerLookupFailureReported) { return; }
    this.headerLookupFailureReported = true;
    this.dialogService.openSnack('common.table.editRows.lookupLoadFailed', { icon: 'warning', sticky: true });
  }

  /** The structure a row's own category/brand resolve to, or `undefined` when the row names
   *  neither or the structure cannot be found.
   *
   *  Memoized by category+brand: `ProductStructureService.findStructure` returns a `_.cloneDeep` of
   *  its cached structure on every call, and the callers below run it per row — on a grid whose
   *  rows nearly all share one category/brand, that is one deep clone of the whole structure per
   *  row per emission for an answer that cannot change during the mount.
   *
   *  ONLY a RESOLVED structure is cached, never a miss. `findStructure` fills its own two lookup
   *  maps from HTTP calls issued in its constructor and deliberately does not cache a miss for
   *  exactly this reason — until those land, every lookup misses. This component can be asking
   *  well inside that window: `loadStructure` takes `productStructure` straight from the
   *  `productStructureCond` @Input (rehydrated dynaData), so the grid has a structure while the
   *  service still has empty maps. Caching `undefined` there poisoned the row's `cat_brand` key for
   *  the LIFE of the component — `needsEmptyHoloStamp` / `stampLoadedEmptyHolos` then matched no
   *  row ever again, so the brand-6 holo waiver never fired and a holo-less brand-6 row stayed
   *  unsavable with its holo cell hidden and no notice: the silent dead-end the waiver exists to
   *  close, reintroduced by its own memo. */
  private rowStructureCache = new Map<string, ProductStructure>();

  private rowStructureOf(row: { [k: string]: any } | undefined): ProductStructure | undefined {
    if (!row || row['categoryId'] == null || row['brandId'] == null) {
      return undefined;
    }
    const key = `${row['categoryId']}_${row['brandId']}`;
    const cached = this.rowStructureCache.get(key);
    if (cached) {
      return cached;
    }
    const found = this.productStructureService.findStructure(row['categoryId'] as number, row['brandId'] as number);
    if (found) { this.rowStructureCache.set(key, found); }
    return found;
  }

  /** The id of the structure a row's own category/brand resolve to — see `rowStructureOf`. */
  private rowStructureId(row: { [k: string]: any } | undefined): number | undefined {
    return this.rowStructureOf(row)?.id;
  }

  /** Whether any row still WANTS the loaded-empty `holos` stamp — i.e. belongs to the structure the
   *  claim was made for and does not already carry an empty list. The stamping callers use this to
   *  skip the work (and, in `getValues`, the grid-wide clone) on a re-emission that would change
   *  nothing. */
  private needsEmptyHoloStamp(rows: { [k: string]: any }[]): boolean {
    const answeredStructureId = this.productStructure?.id;
    if (answeredStructureId == undefined) {
      return false;
    }
    return (rows || []).some(el => el
      && this.rowStructureId(el) === answeredStructureId
      && !(Array.isArray(el['holos']) && el['holos'].length === 0));
  }

  /** Stamp a LOADED-EMPTY `holos` list — "this product offers no holos", the one claim that waives
   *  the brand-6 holo requirement — onto the rows the claim was actually MADE for, in place.
   *
   *  Scoped to rows whose own category/brand resolve to `this.productStructure`, the structure the
   *  answering lookup (or the structure declaration) speaks for. A search can return rows of mixed
   *  category/brand, and stamping grid-wide waived the requirement for rows of a DIFFERENT
   *  structure whose products do offer holos: `holosKnownEmpty` went true, the holo cell
   *  disappeared (its *ngIf wants a non-empty list) and the movement booked with `holoId` omitted —
   *  the exact silent no-variant booking the waiver's own scoping exists to prevent. Shared by
   *  every caller that can make the claim (`getValues`, `loadStructure`, `applyPendingRestore`) so
   *  the three cannot drift apart again. */
  private stampLoadedEmptyHolos(rows: { [k: string]: any }[]): boolean {
    const answeredStructureId = this.productStructure?.id;
    if (answeredStructureId == undefined) {
      return false;
    }
    let changed = false;
    (rows || []).forEach(el => {
      if (!el || this.rowStructureId(el) !== answeredStructureId) { return; }
      if (Array.isArray(el['holos']) && el['holos'].length === 0) { return; }
      el['holos'] = [];
      changed = true;
    });
    return changed;
  }

  /** Whether a structure renders a `holo` header lookup at all — the template builds one per
   *  `stockfields` entry of type LOOKUP, so a structure declaring none can never emit a holo list
   *  and `holos` would stay unknown (i.e. required) for the life of the mount. */
  private structureHasHoloLookup(structure: ProductStructure | undefined): boolean {
    return (structure?.stockfields || []).some((f: any) => f && f.field === 'holo' && f.type === 'LOOKUP');
  }

  /** Stamp the loaded-empty `holos` waiver onto every row whose OWN structure declares no `holo`
   *  LOOKUP stockfield — the per-row twin of the grid-level claim `loadStructure` makes for
   *  `this.productStructure`.
   *
   *  Two rows the grid-level version cannot reach, both ending in the same silent dead-end (the
   *  row is required to pick a holo, the holo cell's `*ngIf` wants a non-empty list so there is no
   *  cell to pick in, and `rowHoloWaivedKey` needs an array so nothing explains it):
   *
   *  - the RESTORE path, which resolves `this.productStructure` from `items[0]` and stamps `holos`
   *    only from lookup RESPONSES — a structure declaring no holo lookup is never fetched, so no
   *    response ever arrives and every restored row of it stays unknown;
   *  - a row of a DIFFERENT structure than the grid's, on either path. The declaration is that
   *    row's own structure speaking about its own products, so honouring it per row waives nothing
   *    the answering structure was never asked about — the scoping mistake `stampLoadedEmptyHolos`
   *    exists to prevent works the other way round (one structure's EMPTY ANSWER applied to rows of
   *    another).
   *
   *  A row that already carries an ARRAY is left alone: a loaded list — empty or not — is a real
   *  answer, and a non-empty one keeps the requirement standing (fail-closed). */
  private stampStructureDeclaredNoHolos(rows: { [k: string]: any }[]): boolean {
    let changed = false;
    (rows || []).forEach(el => {
      if (!el || Array.isArray(el['holos'])) { return; }
      const structure = this.rowStructureOf(el);
      if (!structure || this.structureHasHoloLookup(structure)) { return; }
      el['holos'] = [];
      changed = true;
    });
    return changed;
  }

  public compareEntity(o: any, o2: any) {
    if (isNullOrUndefined(o) && isNullOrUndefined(o2)) {
      return true;
    }

    if ((isNullOrUndefined(o) && !isNullOrUndefined(o2)) || (isNullOrUndefined(o2) && !isNullOrUndefined(o))) {
      return false;
    }

    return o === o2 || o.id === o2.id;
  }

  getEntitiesDescription(ent: Entity) {
    let value: any = ent;
    if (value && value.id != null) {
      value = value.defaultDescription || value.name || value.description || value.code || value.id;
    }
    return value;
  }

  /** Options for a destination-warehouse control: the Auto sentinel first, then the real
   *  warehouses. Returns a NEW array — `item.warehouses` / `dataExtra['warehouses']` are shared
   *  across every row and must never be mutated.
   *
   *  Memoized by SOURCE-LIST IDENTITY: this is called from an *ngFor inside a virtual-scrolled
   *  grid, i.e. once per rendered row per change-detection pass. Rebuilding the array every time
   *  is pure allocation churn (the rows share one `warehouses` reference), so cache the derived
   *  array against the list it was derived from and rebuild only when that reference — or the
   *  forced flag — actually changes. A WeakMap (not a single slot) because rows may each hold
   *  their own `warehouses` reference: one slot would thrash between them and cache nothing.
   *  Returning a STABLE reference also stops *ngFor's differ from re-running on every pass. */
  private warehouseOptionsCache = new WeakMap<Warehouse[], Warehouse[]>();
  private warehouseOptionsCacheForced = false;
  private readonly warehouseOptionsAutoOnly: Warehouse[] = [AUTO_WAREHOUSE];
  /** Stable empty reference for "the list has not arrived yet" — same *ngFor-differ argument as
   *  the two arrays above; a fresh `[]` per call would re-run the differ every pass. */
  private readonly warehouseOptionsNone: Warehouse[] = [];

  warehouseOptions(list: Warehouse[] | undefined | null): Warehouse[] {
    if (this.warehouseOptionsCacheForced !== this.autoForced) {
      // Forced flag flipped: every cached array is stale. WeakMap has no clear(), and a
      // per-entry invalidation would need the keys, so drop the whole map.
      this.warehouseOptionsCache = new WeakMap<Warehouse[], Warehouse[]>();
      this.warehouseOptionsCacheForced = this.autoForced;
    }

    if (this.autoForced) {
      return this.warehouseOptionsAutoOnly;
    }

    // No list yet (the warehouses search is async, and it can also fail) — render NOTHING, not a
    // lone "Auto". An empty dropdown reads as "still loading", which is the truth; offering Auto
    // as the only choice reads as "Auto is the only option there is", which is a lie the user
    // could act on before the real warehouses arrive.
    if (!list) {
      return this.warehouseOptionsNone;
    }

    const cached = this.warehouseOptionsCache.get(list);
    if (cached) {
      return cached;
    }

    // Behind the cache lookup on purpose: this method runs once per rendered row per
    // change-detection pass, and the collision check is an O(n) scan. Past the cache it runs once
    // per distinct source list instead of thousands of times a second.
    warnOnSentinelWarehouseCollision(list);

    const built = [AUTO_WAREHOUSE, ...list];
    this.warehouseOptionsCache.set(list, built);

    return built;
  }

  warehouseOptionLabel(warehouse: Warehouse): string {
    if (isAutoWarehouse(warehouse)) {
      return this.translateService.instant('warehouse.autoAllocation.option');
    }
    return `${warehouse.id} - ${this.getEntitiesDescription(warehouse)}`;
  }

  /** Native `title` for a warehouse `<option>`. An `<option>` cannot host matTooltip/ngbTooltip
   *  (the browser renders the dropdown list itself, outside Angular's reach), so the native
   *  attribute is the only way to explain what "Automatico" does — which the project's tooltip
   *  rule requires, since the label alone does not say the backend picks the warehouse. Real
   *  warehouses need no explanation, so they get no title. */
  warehouseOptionTitle(warehouse: Warehouse): string {
    if (isAutoWarehouse(warehouse)) {
      return this.translateService.instant('warehouse.autoAllocation.tooltip');
    }
    return '';
  }

  /** The small ".errorVola" hint under a warehouse input: the translated Auto label for the
   *  sentinel, the warehouse's plain name otherwise - the pre-existing rendering, kept for real
   *  warehouses. Deliberately NOT warehouseOptionLabel's `id - name` format: `.errorVola` is
   *  `position: absolute` inside a narrow cell, so that longer string can overlap neighbouring
   *  content. Only the sentinel needed a label at all (it has no name of its own to fall back on). */
  warehouseHintLabel(warehouse: Warehouse | undefined): string {
    if (isAutoWarehouse(warehouse)) {
      return this.translateService.instant('warehouse.autoAllocation.option');
    }
    return warehouse?.name ?? '';
  }

  /** Whether the holo answer for the current round has ARRIVED — a list (empty or not), a failure,
   *  or a structure that declares no holo lookup and so can never emit one. Read by
   *  `rowValueWarningKey`'s `holoUnknown` branch below.
   *
   *  `holos` is stamped onto the rows by a lookup that answers INDEPENDENTLY of the three the row
   *  body is gated on: the template renders a row as soon as `warehouses`, `languages` and
   *  `conditions` are present, and the holo list arrives from its own emission afterwards. So
   *  "brand-6 row with no `holos` array" is the normal state of every brand-6 row for the first
   *  moments of every ordinary search, and reading it as the stuck-row case flashed the warning
   *  triangle — "the row stays blocked until a new search reloads the lists" — on every row of
   *  every brand-6 grid during routine loading. A warning whose whole value is that it means
   *  something cannot cry wolf on the happy path.
   *
   *  Deliberately a "has the answer landed" flag rather than adding `holos` to the row-render gate:
   *  a structure that declares no holo lookup stamps `[]` and would still render, but one whose
   *  lookup FAILS never stamps at all, and gating the row body on it would hide the very rows the
   *  warning exists to explain. */
  private holoAnswerSettled = false;

  /** Whether a ROW is sendable: the per-row save button's `[disabled]`, the row test `allsValid`
   *  counts with, AND the gate `setAll` filters the bulk with — one predicate for all three.
   *
   *  The template used to inline `!item.quantity`, which is falsy for NaN but TRUE for Infinity —
   *  a different predicate from the bulk path's, so the two disagreed about which rows are
   *  sendable and only the bulk one was protected.
   *
   *  It has to test the same FACTS `filterFN` reads off the model, not merely the same fields,
   *  or it drifts again in the direction that loses data: `filterFN` requires the getModel-DERIVED
   *  `conditionId`/`languageId`, so a row carrying a `conditionRow` object with no `id` was
   *  counted and offered for saving while the bulk dropped it — and the success path then reset
   *  the grid and deleted the draft. Hence `?.id` rather than the object.
   *
   *  It is allowed to be STRICTER than `filterFN`, and is for brand 6 below; it may never be
   *  looser. Both save paths gate on this first and remember only the rows it passed, so a
   *  stricter test costs a row nothing — it stays filled on screen, out of the "save N items"
   *  count, with its own save button visibly greyed — while a looser one hands the wire belt a
   *  row to drop silently after the commit has already reported success.
   *
   *  The destination clause mirrors getModel's: an Auto row carries no `warehouseToId` at all
   *  (it sends `strategy` instead), so requiring a `warehouseRow` id outright would disable the
   *  button for a user whose role forces automatic allocation.
   *
   *  Brand 6 needs a real `holoRow` — but only where the row actually offers holos to choose
   *  from. THE HOLO IS NOT OPTIONAL, and gating both save paths on it here is a DELIBERATE
   *  behaviour change (product decision, 2026-08-12): the old bulk path committed a brand-6 row
   *  with no chosen holo because its `holoId !== undefined` test was vacuously true — a defect,
   *  not a workflow. A holo-bearing product booked with no variant recorded is wrong stock, so
   *  such a row now stays on screen, out of the count, until a holo is picked. The model cannot
   *  make the offers-holos distinction (`getModel` emits `holoId: null` both for "not picked" and
   *  for "this product has none"), and requiring it unconditionally made a brand-6 row with an
   *  empty `holos` list unsavable by EVERY path: the operator fills it completely, no button ever
   *  enables and no message explains why. The test is `!= undefined` on the id rather than
   *  truthiness, because a lookup whose id is 0 is a legitimate choice. The language / condition /
   *  destination tests stay truthy on purpose, matching `filterFN`.
   *
   *  The purchase-price clause is the same kind of strictness: a finite NEGATIVE price is the one
   *  stored shape the screen renders as a value while the payload builder silently drops it
   *  (`isNegativePurchasePrice`) — the movement would book with no cost behind a success toast.
   *  Blank-rendering junk (NaN, a garbage string) stays strippable: dropping it matches the blank
   *  the operator sees.
   *
   *  "This product offers no holos" is a claim only a LOADED list can make, hence
   *  `Array.isArray(...) && length === 0` rather than a falsy-length test. `getValues` attaches
   *  `holos` to the rows AFTER they are rendered and editable, so reading a MISSING array as "none
   *  offered" dropped the requirement for the whole load window: a brand-6 row was counted by
   *  `allsValid`, its save button enabled, and the movement went out with `holoId` omitted by
   *  `omitBy` — a holo-bearing product committed with no variant recorded, silently, since the save
   *  reports success and `reset()` then blanks the row. Unknown means required. */
  /** The i18n key naming the first reason this row is blocked that the row does NOT show for
   *  itself, or `null` when nothing is being silently refused. This is the feedback half of the
   *  `canSaveRow` strictness: a missing value shows itself (a blank cell in an uncounted row),
   *  but a rendered `0`/`2,5` quantity or a negative price arriving from an older build's draft
   *  looked exactly like a savable row while every save path excluded it with no toast, no cell
   *  error and no console signal — and each autosave re-persisted the stuck row into the draft.
   *  The third case shows even less: an unknown holo list hides the very cell that would have to
   *  be filled (see the branch itself). The template shows a warning icon with this key as its
   *  tooltip, naming the cell to correct or the way out.
   *  Same silent-dead-end pattern the sticky `lookupLoadFailed` toast closes for failed lookups. */
  rowValueWarningKey(item: { [k: string]: any } | undefined): string | null {
    if (!item) {
      return null;
    }
    if (isBlockedQuantity(item['quantity'])) {
      return 'common.table.editRows.rowWarning.quantity';
    }
    if (isNegativePurchasePrice(item['purchasePrice'])) {
      return 'common.table.editRows.rowWarning.purchasePrice';
    }
    // An UNKNOWN holo list on a brand-6 row — `holos` never stamped, as opposed to stamped empty.
    // `canSaveRow` reads unknown as required (fail-closed, deliberately), the holo cell's own
    // *ngIf wants a NON-empty list so there is no cell to pick in, and `rowHoloWaivedKey` needs an
    // array so the info icon cannot speak for it either: the row renders complete, counts for
    // nothing, and explains nothing. Every other row-level refusal in this grid names itself, and
    // this one is reachable on the restore path by two ordinary routes — a draft spanning more
    // than one structure, where the holo lookup answered only for `items[0]`'s and the scoped
    // stamp correctly leaves the rest unknown, and a structure whose own declaration was resolved
    // too late to stamp (see `productStructuresReady`). Fail-closed must not also be silent; the
    // tooltip names the way out, which is the same re-search the `lookupLoadFailed` toast names.
    //
    // The unpicked-holo clause is what keeps this a BLOCKED reason rather than a fact about the
    // lookup. `canSaveRow` reads an unknown list as "holo required" but still passes a row that
    // already carries a `holoRow` — a restore whose holo lookup failed, or a draft spanning two
    // structures, can hand back a brand-6 row with the variant already chosen. Without this clause
    // such a row was counted by `allsValid` with its save button enabled AND wore the warning
    // triangle saying it stays blocked: the two halves of the same predicate contradicting each
    // other on screen. The test mirrors `canSaveRow`'s own (`!= undefined`, so a holo whose id is
    // 0 counts as picked).
    if (item['brandId'] == 6 && !Array.isArray(item['holos']) && this.holoAnswerSettled
      && item['holoRow']?.id == undefined) {
      return 'common.table.editRows.rowWarning.holoUnknown';
    }
    return null;
  }

  /** The i18n key for the one case where `canSaveRow` WAIVES the brand-6 holo requirement, or
   *  `null`. The row is savable and the commit is legitimate — this is a NOTICE, not the blocking
   *  warning above, hence its own icon.
   *
   *  The waiver exists because requiring a holo unconditionally made a brand-6 row whose product
   *  offers none unsavable by every path, with nothing on screen explaining why. But it is reached
   *  through a LOADED-empty list, and a stale `getPermittedValues` filter — holo ids in the
   *  structure's JSON that no longer resolve — makes the lookup return a genuine 200 with
   *  `data: []`. The waiver then books a holo-bearing product with NO variant recorded, and the
   *  only outward sign was the holo cell quietly disappearing (its `*ngIf` on a non-empty list).
   *  Same silent-dead-end pattern the sticky `lookupLoadFailed` toast closes for a lookup that
   *  failed outright: an empty answer is a claim about the data, and the operator has to be able
   *  to see that it was made. Scoping the stamp to the answering structure (`getValues`) keeps the
   *  claim off rows it was never made for; it does not make the claim visible, which is this. */
  rowHoloWaivedKey(item: { [k: string]: any } | undefined): string | null {
    if (!item || item['brandId'] != 6) {
      return null;
    }
    const holos = item['holos'];
    return Array.isArray(holos) && holos.length === 0
      ? 'common.table.editRows.rowWarning.holoWaived'
      : null;
  }

  canSaveRow(item: { [k: string]: any } | undefined): boolean {
    if (!item) {
      return false;
    }
    const hasDestination = this.resolvesToAuto(item['warehouseRow']) || !!item['warehouseRow']?.id;
    const common = isUsableQuantity(item['quantity'])
      && !!item['languageRow']?.id
      && !!item['conditionRow']?.id
      && !isNegativePurchasePrice(item['purchasePrice'])
      && hasDestination;
    const holosKnownEmpty = Array.isArray(item['holos']) && item['holos'].length === 0;
    const holoRequired = item['brandId'] == 6 && !holosKnownEmpty;
    return holoRequired ? common && item['holoRow']?.id != undefined : common;
  }

  saveRow(id: number) {

    const value: { [k: string]: any } = this.copyProducts[id];

    // THE gate, not a hand-picked subset of it. The button's `[disabled]` already calls
    // `canSaveRow`, which leaves only a programmatic caller to catch here — and this used to
    // re-implement two of its clauses (quantity, negative price) by hand, so every clause added
    // to `canSaveRow` (the negative-price one was itself added late) silently never reached this
    // path: a programmatic save of a brand-6 row with no holo passed the copied guards and POSTed
    // the movement with `holoId` stripped by `omitBy` — the exact two-predicates-drifting-apart
    // bug the shared predicate closed on the bulk side. Refuse BEFORE the loading flag goes up,
    // or the row's spinner never comes back down.
    if (!this.canSaveRow(value)) {
      return;
    }

    // A row already on the wire — through its own in-flight save (the spinner swap hides the
    // button, so this catches programmatic callers) or through a bulk commit that snapshotted it
    // (the button disables on isRowBulkLocked, same reason) — must not be POSTed a second time:
    // its values are only blanked when the in-flight response comes back, so it still looks
    // savable. Scoped to the bulk's OWN rows: a row the bulk never carried is independent work
    // and stays savable during the round trip.
    if (this.isRowSaving(value) || this.isRowBulkLocked(value)) {
      return;
    }

    // Keyed on the ROW, not on its index: `deletedRow` on any row above this one shifts every
    // later index, so an index-keyed flag left the spinner on a stranger and re-enabled the save
    // button of the row still in flight — a second press POSTs the same movement again. The
    // in-flight flag itself goes up inside `saveDefinitive`, beside the handlers that bring it
    // down — a caller-side raise here would latch the spinner forever the moment anything (a
    // spec's spy) stands in for that method.
    const uid = this.rowUid(value);
    let toSave = this.getModel(value, false);
    toSave = _.omitBy(toSave, isUnsendable);

    // Only THIS row was committed, so only this row is blanked. The per-row save used to clear
    // the whole grid — every other row lost what the operator had typed into it, with the draft
    // deleted in the same success handler and the restore picker suppressed, i.e. exactly the
    // loss the committed-row set exists to stop, arriving through the other save path.
    this.saveDefinitive(uid, toSave, TypeSaveInsert.SINGLE, new Set<string>([uid]));


  }

  /** @param rowUid the `ROW_UID` of the row a per-row save is for — the key its in-flight flag is
   *  stored under, and `undefined` for a bulk save, which has no single row to name.
   *  @param committedRows the `ROW_UID`s of the rows this commit actually carried — the only rows
   *  its success path may blank (see `reset`). It is a PARAMETER rather than an instance field on
   *  purpose: both save paths write it, the per-row save buttons stay live during a bulk save, and
   *  a shared field meant an interleaved per-row save re-pointed the set the in-flight bulk was
   *  going to consume — blanking rows that bulk had skipped, or leaving committed ones filled to
   *  be re-sent as duplicate movements. `undefined` still means "every row", for a caller that has
   *  no row set to name. */
  saveDefinitive(rowUid: string | undefined, itemToSave: WarehouseMovementDTORequiredPrev | WarehouseMovementDTORequiredPrev[], type: TypeSaveInsert, committedRows?: ReadonlySet<string>) {

    // The in-flight flag (`isBulkSaving` / the row spinner key) goes up HERE, beside the success
    // and error handlers that bring it down — not in the caller. A caller-side set drifts from
    // the clear the moment the two are separated: `setAll` used to raise it before calling in,
    // so anything that stands in for this method (a spec's spy) latched the flag up for good and
    // every later per-row save was silently refused by the cross-path guard.
    this.loadingType[(rowUid != undefined ? rowUid : '') + type] = true;
    if (type === TypeSaveInsert.MULTIPLE) {
      // The GATING copy of the committed-row set (see `isRowBulkLocked`) — not the consuming
      // copy, which stays a parameter for the reason the param doc gives. Raised and cleared in
      // lockstep with the bulk `loadingType` flag above/below, only ever written by the bulk
      // path, and only one bulk can be in flight (`setAll` refuses a second).
      this.bulkCommittedRows = committedRows ?? null;
    }

    this.store.dispatch(new BaseAction(LayoutActionType.LoadingBlock, true));
    // Gate the autosave loop for the duration of this commit. Without this,
    // a 5s interval tick can fire saveDraft mid-commit and (a) overwrite the
    // draft with mid-reset() empty-value rows, or (b) land after the
    // post-commit deleteDraft and resurrect the row on the backend.
    // Cleared via finalize() so the flag releases on success, error, AND
    // unsubscribe (route-change destroy).
    this.draftService.setIsSaving(true);

    this.subs.add(
      this.setInsertService.saveMovements(itemToSave, type, this.sessionId).pipe(
        debounceTime(200),
        map(a => a.data as any[]),
        catchError(err => {
          this.clearCommitBlock(type);
          this.loadingType[(rowUid != undefined ? rowUid : '') + type] = false;
          // Scoped to the bulk, like every sibling clear here: `loadAll` is written by `setAll`
          // alone and drives the bulk spinner. Cleared blanket, a per-row save completing DURING
          // a bulk (deliberately allowed — see `isRowBulkLocked`) put the "save N items" button
          // back while the bulk was still on the wire, and the press it invited died silently at
          // `setAll`'s `isBulkSaving()` guard: no spinner, no toast, no request — the
          // dropped-press anti-pattern this component fixes everywhere else.
          if (type === TypeSaveInsert.MULTIPLE) {
            this.loadAll = false;
            this.bulkCommittedRows = null;
          }

          return throwError(() => {
            return err;
          });
        }),
        finalize(() => this.draftService.setIsSaving(false)),
      ).subscribe(d => {



          this.clearCommitBlock(type);

          this.loadingType[(rowUid != undefined ? rowUid : '') + type] = false;
          // Scoped for the reason the error arm above gives at length.
          if (type === TypeSaveInsert.MULTIPLE) {
            this.loadAll = false;
            this.bulkCommittedRows = null;
          }

          // A 2xx whose body carries no movement at all. `map(a => a.data as any[])` passes a null
          // or absent `data` straight through, and `[]` is a legal JSON body, so this is reachable
          // from the server side of the very dereference `setAll`'s empty-payload guard closes on
          // the client side: `d[0].warehouseSession` below throws INSIDE the subscribe on a first
          // commit, and the throw takes the whole rest of the handler with it — no toast, no
          // `reset()`, no `settleDraftAfterCommit()` — surfacing as the global handler's raw,
          // untranslated message.
          //
          // Refused rather than repaired, because "no movements were created" is not something the
          // success path can be run over: `reset(committedRows)` would blank rows the backend never
          // booked, and the settle would tear down (or rewrite without them) the draft that is
          // their only other copy. Bailing here leaves the grid and the draft exactly as the press
          // found them, so the operator can press again — and says so, instead of a stack trace.
          // The flags above are already down, so nothing is left spinning.
          //
          // Sticky, and through the NAMED form. The positional one puts `'error'` in the ICON slot
          // and leaves `time` undefined, which is the 4000ms default (2000ms under the `short`
          // `display.toastDuration` preset) — not stickiness, the exact trap `SnackOptions.sticky`
          // documents. This toast is the ONLY sign a 2xx booked nothing: the handler returns before
          // the reset, the success toast and the settle, so the rows stay filled and the screen is
          // otherwise unchanged. Missed, the press reads as having worked.
          if (!Array.isArray(d) || d.length === 0) {
            this.dialogService.openSnack('common.message.noMovementsCreated', { icon: 'error', sticky: true });
            return;
          }

          // Every returned movement carries a populated `warehouse` (no @JsonIgnore on the
          // backend entity), so describeAllocationSplit() would return a non-empty string even
          // for a fully-manual save. Only report the split when the payload that was actually
          // just committed used automatic allocation - i.e. at least one saved row carried a
          // strategy. itemToSave is either a single model or an array of them (SINGLE vs
          // MULTIPLE), so check both shapes.
          const savedRows = Array.isArray(itemToSave) ? itemToSave : [itemToSave];
          const autoRows = savedRows.filter(row => !!row['strategy']).length;
          const split = autoRows > 0 ? describeAllocationSplit(d) : '';
          // The split is folded from the WHOLE response, which for a mixed commit also contains
          // the manually-placed rows - there is no reliable way to attribute a returned movement
          // back to the row that produced it. So only claim "allocated automatically" when every
          // saved row was Auto; for a mixed commit state the neutral fact instead (these are the
          // movements that were created), which is true of manual and auto rows alike.
          const splitKey = autoRows === savedRows.length
            ? 'warehouse.autoAllocation.splitToast'
            : 'warehouse.autoAllocation.splitToastMixed';
          // ONE toast, not two: MatSnackBar shows a single snackbar at a time, so the generic
          // "loadSuccess" opened further down would immediately dismiss a separate split toast
          // and the user would never see the allocation. Fold the split INTO the success message.
          const successKey = split ? splitKey : 'common.message.loadSuccess';
          const successParams = split ? { split } : undefined;

          if (!this.sessionId) {

            this.sessionId = (d[0].warehouseSession as WarehouseSession).id;

            this.router.navigateByUrl('app/set-insert-out/' + '' + this.sessionId, {
              skipLocationChange: false,
            }).then(() => {
              this.store.dispatch(new BaseAction(DynaConfActionType.Refresh));
              this.dialogService.openSnack('common.message.updateIdSuccess', 'info', 5000, 'top', 'right');
              this.dialogService.openSnack(successKey, { icon: 'info', time: 5000, params: successParams });
              this.reset(committedRows);
            });
          }

          // The header is BATCH tooling, so it is cleared after a bulk commit (the batch it was
          // set up for is done) and SURVIVES a per-row save. `reset()` is scoped to the one
          // committed row there — the other rows keep their values — so clearing the header (and,
          // with keep-values off, deleting its kept storage keys via the setters' `setKept`)
          // would leave those survivors unmanageable: the operator re-enters quantity, warehouse
          // and language after every green per-row save. Scoping `reset()` without scoping this
          // split the two halves of the same cleanup. The lookup-box clear (`resetValueOnFire`)
          // is gated with it — the boxes must keep showing the values the header still holds.
          const clearHeader = type !== TypeSaveInsert.SINGLE;
          if (clearHeader) {
            this.resetValueOnFireSubject.next(!this.persistValueOn);
          }
          this.dialogService.openSnack(successKey, { icon: 'info', time: 5000, params: successParams });
          this.reset(committedRows);
          if (clearHeader) {
            this.resetHeader();
          }
          // AFTER reset() above, so the rows this commit carried are already blanked and drop out
          // of the payload: what is left is exactly the work the operator still has on screen.
          // Rewrites the draft when anything remains, deletes it when nothing does.
          const draftKept = this.settleDraftAfterCommit();
          // Suppress the next mount's draft picker ONLY when the commit left nothing behind — any
          // picker right after a decisive Save that emptied the grid is confusing, and the flag is
          // set synchronously so the about-to-mount /:id route's SetInsertConfComponent.ngOnInit
          // sees it. When rows REMAIN the picker is the only way back to them: the first commit
          // navigates to /:id, which destroys this component, and the remounted grid reloads
          // untouched rows from the server — so suppressing it there re-created the very loss the
          // draft rewrite above exists to prevent, one line after writing the draft. Direct /:id
          // visits still get the picker because the flag is only ever set on commit.
          if (!draftKept) {
            this.draftService.markJustCommitted();
          }

          // reset() above cleared the row values but left the rows selected. The first save
          // navigates to /:id and reloads (re-applying kept values through the load path), but
          // later saves don't reload — so when keep-values + select-all are on, re-apply the kept
          // header values to the still-selected rows here. Deferred to the next tick to avoid
          // NG0100 (re-applying flips the template's allsValid()/allsValidValue).
          //
          // Gated on `clearHeader` — i.e. BULK saves only. A per-row (SINGLE) save keeps the
          // header, so this repaint would refill the one row reset() just blanked from the
          // retained header values: the committed row re-enters the "save N items" count looking
          // exactly like an unsaved row, and the next Save all POSTs its movement a second time.
          if (clearHeader && this.persistValueOn && this.productSelectValueAll) {
            setTimeout(() => this.loadStructureForSelectAll(true), 0);
          }

        })
    );
  }

  /** Blanks the committed rows after a successful save.
   *
   *  `committed` names the rows the commit actually carried, by `ROW_UID` (see `setAll` and
   *  `saveRow`); a row the commit skipped keeps everything the operator typed into it, because
   *  the save it was left out of reports success and would otherwise leave no trace it ever
   *  existed. `undefined` means "every row", for a caller with no set to name. */
  private reset(committed?: ReadonlySet<string>) {

    if (this.copyProducts && this.copyProducts.length > 0) {
      this.copyProducts.map((value: { [k: string]: any }) => {
        if (committed && !committed.has(this.rowUid(value))) {
          return value;
        }
        // Unconditionally, like every sibling field — not just for brand 6. Any structure can
        // declare a holo LOOKUP, and with the header reset no longer broadcasting its cleared
        // values onto the rows (`resetHeader` suppresses the paint), this is the only thing left
        // that clears a committed row's holo: a brand guard here left `holoRow` populated on every
        // other brand, so the NEXT batch typed into the same still-selected rows went out carrying
        // the previous batch's `holoId` — stock booked against a variant the operator never chose,
        // with no error anywhere.
        value['holoRow'] = undefined;
        value["conditionRow"] = undefined;
        value["languageRow"] = undefined;
        value['purchasePrice'] = undefined;
        value["quantity"] = undefined;
        this.productStructure?.stockfields?.forEach(field => {
          value[field.field as string] = undefined;
        });
        value['warehouseRow'] = undefined;
        value['comment'] = '';
        // Clearing the row's VALUES isn't enough: the per-cell editable flags
        // (set to false by productGestione setters when the user manually fills
        // a cell - they mark "user owns this, don't overwrite from header")
        // would persist as false. Apply-from-header (quantityAll, entityValueAll,
        // setValueFieldAll, ...) gates on d.editable[FIELD], so without this
        // reset every cell the user filled before save stays untouchable by the
        // header inputs afterwards. Re-mark them editable so the next round of
        // header input can populate them.
        if (value['editable'] && _.isObject(value['editable'])) {
          const ed = value['editable'] as { [k: string]: any };
          ed[TypeEditTable.COMMENT] = true;
          ed[TypeEditTable.QUANTITY] = true;
          ed[TypeEditTable.PURCHASEPRICE] = true;
          ed[TypeEditTable.WAREHOUSES] = true;
          ed[TypeEditTable.HOLOS] = true;
          ed[TypeEditTable.LANGUAGE] = true;
          ed[TypeEditTable.CONDITION] = true;
          this.productStructure?.stockfields?.forEach(field => {
            if (field.field) { ed[field.field as string] = true; }
          });
        }
        return value;
      });

    }



  }

  set entityValueAll(id: number | undefined) {
    if (isAutoWarehouse({ id })) {
      this.entityAll = AUTO_WAREHOUSE;
      this.errorCustomAll = false;
      this.setKept(keepValueWarehouse, AUTO_WAREHOUSE_ID);
      if (this.suppressHeaderPaint) { return; }
      this.copyProducts.map((d) => {
        if (d && d.active && d.editable && d.editable[TypeEditTable.WAREHOUSES]) {
          d.warehouseRow = this.entityAll;
        }
      });
      return;
    }

    this.entityAll = this.dataExtra['warehouses']?.find(d => d && (d.id == id));

    this.setKept(keepValueWarehouse, id);

    if (this.entityAll && this.entityAll.id != undefined) {

      this.errorCustomAll = false;

    } else {

      this.errorCustomAll = true;

      // Guard `dataExtra['warehouses']` the same way line 904 already does: this setter is also
      // fired from a deferred setTimeout in loadHeaderValues(), which can run after the view/data
      // has gone (e.g. the component destroyed) — an unguarded `.map` there throws and, from a
      // detached timer, aborts whatever is running at that moment.
      this.entityAll = ((this.dataExtra['warehouses'] ?? []).map((n: Warehouse) => {

        if (id && (n.id as number)?.toString().includes(id.toString() as string)) {
          const a: any = { id: '9999_pp__santiagoMadridAllssWarehouses', name: '' };

          return a;
        }
        return;
      })).find((d: Warehouse) => d && d.id != undefined);

      setTimeout(() => {

        this.genericFieldAll?.valueAccessor?.writeValue(undefined);
        this.entityAll = undefined;
        this.errorCustomAll = true;

      }, 0);


    }

    if (this.suppressHeaderPaint) { return; }

    this.copyProducts.map((d) => {

      if (d && d.active && d.editable && d.editable[TypeEditTable.WAREHOUSES]) {
        d.warehouseRow = this.entityAll;
        // this.productGestione(index, false).entityValueWarehouse = this.entityAll?.id || undefined;
      }

    });

  }

  get entityValueAll(): any {
    return this.entityAll?.id;
  }


  public get inverseTranslation(): string {

    if (!this.viewport || !this.viewport["_renderedContentTransform"]) {
      return "60px";
    }

    // Clamp so a small/zero offset never produces "--60px" (invalid CSS,
    // parsed as a custom-property name) and the sticky header position moves
    // monotonically: 60px at the top of the list, sliding up as we scroll
    // past 60px of content. The CDK internal still updates async during a
    // scroll; that race is dev-mode-only NG0100 noise, harmless in prod.
    const offset = this.viewport["_renderedContentOffset"] as number;
    const numericOffset = typeof offset === "number" ? offset : parseInt(String(offset), 10) || 0;
    return `${Math.min(60 - numericOffset, 60)}px`;

  }

  get persistValue() {
    return this.persistValueOn;
  }

  set persistValue(v: boolean) {
    this.persistValueOn = v;

    this.setKept(KeepHeaderValues, this.persistValueOn);

    if (!v) {

      this.removeKept(keepSelectAll);

      this.productStructureCond?.allFields?.forEach(field => {
        this.removeKept(keepValue + field.field);
        this.removeKept(keepValue + field.field + 'Row');

      });

      this.removeKept(keepValueComment);
      this.removeKept(keepValueWarehouse);
      this.removeKept(keepValueQuantity);
      this.removeKept(keepValuePurchasePrice);
    }
  }


  clonedRow(id: number) {
    const arrFirst = _.cloneDeep(this.copyProducts);

    arrFirst.splice(id, 0, this.copyProducts[id]);

    const cloned = _.cloneDeep(arrFirst);

    // `ROW_UID` is an ordinary property, so the deep clone gives the duplicate the SAME identity as
    // the row it was copied from — two rows a commit's `reset()` would then blank as one. Drop it
    // from the inserted copy (index `id`; the source is now at `id + 1`) and let the setter mint a
    // fresh one. The source keeps its uid on purpose: a commit already in flight named THAT row,
    // and the brand-new duplicate is not part of it.
    if (cloned[id]) { delete (cloned[id] as { [k: string]: any })[ROW_UID]; }

    this.copyProducts = cloned;
  }

  deletedRow(id: number) {

    const arrFirst = _.cloneDeep(this.copyProducts);

    arrFirst.splice(id, 1);

    this.copyProducts = _.cloneDeep(arrFirst);

  }

  /** Resolves a kept value AND says which area answered — per-tab first, then the shared copy —
   *  and whether it came out of PRE-NAMESPACE (legacy) storage. All reads go through
   *  safe-storage: these are convenience preferences and a refused access must never break the
   *  edit grid.
   *
   *  The area matters to the purge in `resolveKept` (dropping what could not be used) and getting
   *  it wrong there destroyed the healthy copy in the OTHER area, so it is resolved here rather
   *  than guessed at the call site. The legacy flag matters to `keptString`'s sentinel test:
   *  only a pre-namespace build ever STRINGIFIED nil into storage, so 'null' found under the
   *  namespaced, prefixed key can only be a value the operator typed — dropping the flag here is
   *  how a typed "null" comment was purged as poison. */
  private getKeptFrom(key: string, skip?: ReadonlySet<StorageArea>): { area: StorageArea; raw: string; legacy: boolean } | null {
    const local = skip?.has('local') ? null : this.peekKeptArea('local', key);
    // A local copy marked "wins" supersedes the per-tab one: it was written by THIS TAB's
    // `setKept` on a refused session write, i.e. at the one moment this tab's session copy was
    // PROVABLY stale — and the clear that normally handles that can itself be refused while reads
    // keep working, which left the stale per-tab value authoritative for the life of the origin.
    // `peekKeptArea` has already resolved the marker's ownership: another tab's marker decodes
    // with `wins: false`, because the refusal it records says nothing about OUR session copy
    // (see KeptWinsPrefix).
    if (local?.wins) {
      return { area: 'local', raw: local.value, legacy: false };
    }
    const session = skip?.has('session') ? null : this.peekKeptArea('session', key);
    if (session !== null) {
      if (session.legacy) {
        this.migrateLegacyKept('session', key, session.value);
      }
      return { area: 'session', raw: session.value, legacy: session.legacy };
    }
    if (local !== null) {
      if (local.legacy) {
        this.migrateLegacyKept('local', key, local.value);
      }
      return { area: 'local', raw: local.value, legacy: local.legacy };
    }
    return null;
  }

  /** Reads one area's kept VALUE without writing anything, or `null` for "this area keeps nothing",
   *  saying which generation of storage answered.
   *
   *  The namespaced slot is consulted first and is the only one the prefix is stripped from —
   *  nothing but this build writes there, so a leading `KeptValuePrefix` is always encoding and
   *  never the first character of the operator's value. The un-namespaced key is whatever a build
   *  that predates the namespace left behind and is returned VERBATIM: stripping a `v` off it is
   *  how `vendita fiera` came back as `endita fiera`, painted onto every selected row and committed
   *  with the movements.
   *
   *  The tombstone is only ever written to the namespaced slot, which is read first, so it masks a
   *  legacy copy underneath it as well. */
  private peekKeptArea(area: StorageArea, key: string): { value: string; legacy: boolean; wins: boolean } | null {
    const stored = readStorage(area, keptStorageKey(key));
    if (stored !== null) {
      if (stored === KeptTombstone) {
        return null;
      }
      if (stored.startsWith(KeptWinsPrefix)) {
        // `w<tabId>|<value>` — wins only for the tab that wrote it (see KeptWinsPrefix). A copy
        // that cannot prove it is ours (foreign id, no separator, this tab has no id) is still a
        // perfectly good SHARED value: decoded plain, served session-first like any local copy.
        const rest = stored.slice(KeptWinsPrefix.length);
        const sep = rest.indexOf(KeptWinsSeparator);
        if (sep === -1) {
          return { value: rest, legacy: false, wins: false };
        }
        const owner = rest.slice(0, sep);
        const value = rest.slice(sep + KeptWinsSeparator.length);
        return { value, legacy: false, wins: owner !== '' && owner === peekTabId() };
      }
      return { value: stored.startsWith(KeptValuePrefix) ? stored.slice(KeptValuePrefix.length) : stored, legacy: false, wins: false };
    }
    const legacy = readStorage(area, key);
    return legacy === null ? null : { value: legacy, legacy: true, wins: false };
  }

  /** Moves a pre-namespace copy into the namespaced slot, once, on the read that found it.
   *
   *  Not required for correctness — `peekKeptArea` falls back to the legacy key on every read — but
   *  without it the two copies sit in the operator's quota for the life of the origin, in the quota
   *  the storage probe exists to protect. The legacy key is dropped only when the namespaced write
   *  was ACCEPTED, or a refusing area would lose the value it was still holding. */
  private migrateLegacyKept(area: StorageArea, key: string, value: string): void {
    if (writeStorage(area, keptStorageKey(key), KeptValuePrefix + value)) {
      removeStorage(area, key);
    }
  }

  private getKept(key: string): string | null {
    return this.getKeptFrom(key)?.raw ?? null;
  }

  /** Persists a kept header value. Callers hand over the RAW value, never `'' + value`:
   *  stringifying it is what wrote the literal 'null' / 'undefined' / 'NaN' into storage, and
   *  the restore below then parsed those sentinels back into NaN (see `keptNumber`). A value
   *  with nothing to remember (cleared box, non-finite number) removes the key instead. */
  private setKept(key: string, value: string | number | boolean | null | undefined, dropStaleOnRefusal = true): void {
    // Same predicate the two save paths sanitise the payload with, called rather than copied:
    // a later change to what counts as unsendable must not leave storage round-tripping a value
    // the wire refuses.
    if (isUnsendable(value)) {
      this.removeKept(key);
      return;
    }
    const raw = String(value);
    const sessionAccepted = this.writeKeptArea('session', key, raw, dropStaleOnRefusal);
    // A refused session write marks the local copy as superseding (see KeptWinsPrefix): the
    // session slot may still be serving a stale value that also refused to be cleared, and the
    // read order alone would hand that stale value to the next load. The marker names THIS tab —
    // the refusal proves only this tab's session copy stale, and an unscoped marker overrode
    // every other tab's healthy one. An accepted session write stores the plain prefix, which is
    // also what heals a marker left by an earlier refusal. `getTabId` (minting): a tab actively
    // writing kept values may claim an id, unlike the read side.
    this.writeKeptArea('local', key, raw, dropStaleOnRefusal,
      sessionAccepted ? KeptValuePrefix : KeptWinsPrefix + getTabId() + KeptWinsSeparator);
  }

  /** Writes one area's copy, and — this is the point — drops the key when the write is REFUSED.
   *
   *  These keys are "latest wins" slots and `getKept` reads session first, so ignoring the
   *  boolean `writeStorage` returns leaves the PREVIOUS value in place and authoritative: a
   *  header quantity changed from 7 to 2 in a tab whose sessionStorage is refusing writes (Safari
   *  private window, blocked cookies, disk pressure) would restore as 7 on the next load and be
   *  painted onto every still-editable selected row. Losing the preference is fine; silently
   *  keeping a stale one that gets committed is not.
   *
   *  The one refusal that must NOT drop the key is the one where the area already holds exactly
   *  what was being written — a re-applied header value, the same number typed again. There is no
   *  stale value to protect anyone from there, and deleting it would destroy a correct durable
   *  copy (the shared `localStorage` one that seeds the next tab) on account of a transient quota
   *  condition that changed nothing.
   *
   *  `dropStaleOnRefusal` is false for a key that is NOT a latest-wins slot feeding a save — the
   *  visible-column layout is the one such caller. Nothing there is ever stamped onto a row or
   *  put on the wire, so a stale layout costs the operator a column they had just hidden, while
   *  dropping the key costs them the ENTIRE layout: `loadVisibleColumns` reads nothing, the set
   *  comes back empty and `isColumnVisible` is false for every field. Deleting a good preference
   *  because a quota-refusing area would not accept an edit to it is the worse of the two. */
  private writeKeptArea(area: StorageArea, key: string, raw: string, dropStaleOnRefusal = true, prefix: string = KeptValuePrefix): boolean {
    // Stored prefixed, under the namespaced key, and read back through `peekKeptArea`: that is what
    // keeps the tombstone out of the range of values an operator can type into the header boxes
    // without putting an earlier build's unprefixed values at risk of being decoded. Returns
    // whether the write was ACCEPTED — `setKept` uses the session answer to decide whether the
    // local copy must carry the superseding `KeptWinsPrefix`.
    if (writeStorage(area, keptStorageKey(key), prefix + raw)) {
      return true;
    }
    if (!dropStaleOnRefusal) {
      return false;
    }
    // `peek`, not `read`: a migration write here would be refused by the same area that just
    // refused the value, so it can only add throwing calls to a path that already counts them.
    const current = this.peekKeptArea(area, key)?.value ?? null;
    if (current === raw || current === null) {
      // Nothing stale is readable there — the key was never written, it is already a tombstone,
      // or the area refuses reads outright — so there is no value to protect anyone from and the
      // removal below would be two more throwing calls. That cost is not theoretical: the header
      // quantity/price boxes call setKept on EVERY keystroke, so on an area that refuses (Safari
      // private window, blocked cookies) the full path is 8 thrown-and-caught storage calls per
      // character typed, each also notifying the failure sink, on the main thread.
      return false;
    }
    this.clearKeptArea(area, key);
    return false;
  }

  /** Removes one area's copy, falling back to a tombstone when the removal is itself refused —
   *  every reader here treats the tombstone as "nothing kept", so the stale value cannot come
   *  back. (`removeStorage` reports nothing, hence the read-back rather than a boolean.)
   *
   *  BOTH generations of the key go: `peekKeptArea` falls back to the un-namespaced one, so a
   *  legacy copy left behind here would resurface as the value this call exists to drop. One
   *  tombstone covers them both, because it goes in the namespaced slot, which is read first. */
  private clearKeptArea(area: StorageArea, key: string): void {
    const namespaced = keptStorageKey(key);
    removeStorage(area, namespaced);
    removeStorage(area, key);
    if (readStorage(area, namespaced) !== null || readStorage(area, key) !== null) {
      writeStorage(area, namespaced, KeptTombstone);
    }
  }

  /** Restores a kept NUMERIC header value, or `undefined` when there is nothing usable stored.
   *
   *  Storage holds strings, so every restore here is a parse - and `parseInt('null')` is NaN.
   *  NaN is the worst possible outcome because it is invisible: it passes `!= undefined`
   *  (filterFN, getModel) and `_.isNil` (setAll's omitBy), renders as a BLANK box (the number
   *  directive maps NaN to null on write), and `JSON.stringify(NaN)` is `null` - so a row the
   *  user never filled in was POSTed to /v2/sessions/{id}/movementsbulk with `quantity: null`
   *  and failed the whole bulk with `error.session.execution_errors`. A NaN warehouse or lookup
   *  id fails even quieter: the row is simply dropped by filterFN and never saved at all.
   *
   *  `setKept` no longer writes those sentinels, but storage written by an earlier build still
   *  holds them (and `'' + NaN` is 'NaN', which re-parses to NaN, so it survives every reload),
   *  hence the finite check rather than a sentinel comparison.
   *
   *  It reads through `toNumeric` — the same reading `coerceQuantity`/`coercePurchasePrice` use —
   *  rather than `parseInt`/`parseFloat`, which parse a PREFIX: `parseFloat('2.5x')` is 2.5 and
   *  `parseInt('1e5', 10)` is 1, both finite, so the very poison this purge exists to catch was
   *  restored as a real header value and painted onto every selected row. `Number(...)` rejects
   *  the whole string instead, which is what "unusable as a number" has to mean if the three
   *  readings of one stored value are to agree.
   *
   *  It is deliberately NOT the app's lenient `parseNumber`. That parser is preference-aware and
   *  resolves a lone separator by the user's own grouping glyph — correct for what a human TYPES,
   *  wrong for a canonical stored value: under the `us` preset a kept `'1.234'` (one and a bit)
   *  has a three-digit tail and reads as grouping, i.e. 1234, silently rescaling a saved price by
   *  a thousand. Storage and the wire speak dot-decimal whatever the operator's display preset
   *  says, so they get the canonical reading; only the input directive gets the lenient one. */
  private keptNumber(key: string, decimal = false): number | undefined {
    return this.resolveKept<number>(key, raw => {
      if (raw.trim() === '') { return 'giveUp'; }
      const parsed = toNumeric(raw);
      // Poison written by a pre-fix build ('null' / 'undefined' / 'NaN'). Unlike `keptString`'s
      // sentinel test this is NOT legacy-gated: an unparsable string is unusable as a number
      // whatever generation of storage wrote it ('' + NaN is 'NaN', which a pre-namespace build
      // could stringify and a migration then carries into the namespaced slot). A FRACTION is
      // poison too wherever an integer was kept (a warehouse/lookup id, the header quantity):
      // `parseInt` used to truncate it to a different, plausible-looking value and restore that.
      const usable = decimal ? Number.isFinite(parsed) : Number.isInteger(parsed);
      return usable ? { use: parsed } : 'purge';
    });
  }

  /** Restores a kept STRING, or `undefined` when nothing usable is stored — purging the literal
   *  'undefined'/'null' sentinels a PRE-NAMESPACE build stringified into storage, exactly as
   *  `keptNumber` does for its poison.
   *
   *  The purge is gated on `legacy`: only a pre-namespace build ever wrote stringified nil (the
   *  current one removes the key instead — `setKept`/`isUnsendable`), so a 'null' decoded from
   *  the namespaced, prefixed slot can ONLY be a value the operator typed into the box. Purging
   *  regardless of generation silently destroyed a typed "null" comment in both areas — the
   *  exact collision class the KeptValuePrefix encoding exists to close, reopened one level up. */
  private keptString(key: string): string | undefined {
    return this.resolveKept<string>(key, (raw, legacy) =>
      legacy && (raw === 'undefined' || raw === 'null') ? 'purge' : { use: raw });
  }

  /** The bounded purge-on-read loop every kept restore goes through: read an area, let the caller
   *  decide, and on 'purge' drop that area's copy and fall through to the other one.
   *
   *  Purging here — the one place every restore passes — is what actually ends stale poison: a
   *  caller that merely declines the value leaves it in the area for the life of the origin,
   *  re-read and re-discarded on every load, occupying the quota the storage probe exists to
   *  protect. 'giveUp' declines WITHOUT purging, for a value that is merely empty rather than
   *  poisonous.
   *
   *  Two passes at most — the per-tab copy, then the shared one. Bounded rather than looped
   *  until clean: `clearKeptArea` can itself be refused (an area that accepts neither a removal
   *  nor the tombstone), and a `while` over the same answer would spin forever inside the load
   *  path.
   *
   *  The second pass skips the area the first one read, rather than relying on the purge having
   *  taken. When the area refuses BOTH the removal and the tombstone — a sessionStorage left
   *  poisoned by a pre-fix build in a tab where writes are refused (Safari private window,
   *  blocked cookies, disk pressure) — an unskipped re-read returns the identical poison, the
   *  loop ends and the healthy shared `localStorage` copy one line away is never reached: the
   *  kept header values silently stop restoring in that tab for the life of the origin.
   *
   *  Purges only the area the value was READ from. Purging both destroys a healthy shared
   *  `localStorage` copy — the one every other tab and every future tab seeds from — on the
   *  strength of a stale sentinel sitting in THIS tab's sessionStorage, which is precisely the
   *  shape a pre-fix build left behind. The loop then falls through to the shared copy, so a
   *  key poisoned in both areas is still fully cleaned in one pass. */
  private resolveKept<T>(key: string, read: (raw: string, legacy: boolean) => { use: T } | 'giveUp' | 'purge'): T | undefined {
    const exhausted = new Set<StorageArea>();
    for (let attempt = 0; attempt < 2; attempt++) {
      const found = this.getKeptFrom(key, exhausted);
      if (found === null) { return undefined; }
      const outcome = read(found.raw, found.legacy);
      if (outcome === 'giveUp') { return undefined; }
      if (outcome !== 'purge') { return outcome.use; }
      this.clearKeptArea(found.area, key);
      exhausted.add(found.area);
    }
    return undefined;
  }

  /** Restores a kept BOOLEAN, or `undefined` when there is nothing usable stored — which is not
   *  the same as `false`: the select-all restore only re-applies the structure when a choice was
   *  actually remembered. Legacy storage says that with the literal 'undefined', post-fix storage
   *  says it by having no key at all, and both must read the same — `keptString` purges the
   *  sentinel on the read that finds it, so it no longer sits in the quota forever. */
  private keptBoolean(key: string): boolean | undefined {
    const raw = this.keptString(key);
    if (raw == null || raw === '') { return undefined; }
    return raw === 'true';
  }

  private removeKept(key: string): void {
    this.clearKeptArea('session', key);
    this.clearKeptArea('local', key);
  }

  loadHeaderValues() {

    const keptSelectAll = this.keptBoolean(keepSelectAll);
    this.productSelectValueAll = keptSelectAll === true;
    // Applied unconditionally, INCLUDING when nothing was remembered — `false` is an answer here,
    // not a no-op. Its else-branch force-clears `productSelectValue[i]` and `pr.active` on every
    // row, and skipping that leaves any row still marked active from an earlier cycle selected:
    // the quantity / purchase-price / comment / lookup restores immediately below all gate on
    // `d.active && d.editable[FIELD]`, so the kept header values get painted onto rows the
    // operator never selected, counted by `allsValid`, and committed by the bulk save.
    this.loadStructureForSelectAll(this.productSelectValueAll);

    this.productStructureCond?.allFields?.forEach(field => {
      if (field.stock) {

        if (field.field == 'language' || field.field == 'condition' || field.field == 'holo') {
          // Only assign a lookup id that parsed to a real number: a NaN id resolves no row
          // (`find(p => p.id == NaN)`), which strips the row's condition/language and gets it
          // dropped by filterFN with no error anywhere. keptNumber also purges the poisoned key,
          // so unlike the numeric restores below — which reach the setter and clear it that way —
          // this branch does not have to assign anything to clean up after an old build.
          const keptId = this.keptNumber(keepValue + field.field + 'Row');
          if (keptId != undefined) {
            this.productGestioneFieldsAll((field.field as string) + 'Row').productFieldAll = keptId;
          }

        } else {
          const stored = this.getKept(keepValue + field.field);
          this.valueFiledAll[field.field as string] = stored === 'true';

          this.copyProducts.forEach((d) => {
            if (field.field && d && d.active && (d.editable as { [key: string]: any })[field.field]) {
              (d as { [k: string]: any })[field.field as string] = this.valueFiledAll[field.field as string];
            }
          });
        }
      }
    });

    // comments

    // ONE read, hoisted: the resolver walks up to two keys per area and can fire a
    // legacy-migration write, so calling it three times in one expression tripled the storage
    // work on the boot path. Through `keptString`, not `getKept`: the sentinel a pre-fix build
    // stored ('undefined'/'null') is purged on the read that finds it rather than hand-checked
    // (and left in the quota) here.
    this.commentsAll = this.keptString(keepValueComment) ?? '';

    // warehouse

    setTimeout(() => {
      this.entityValueAll = this.keptNumber(keepValueWarehouse);
    }, 1000);

    // quantity

    this.quantityAll = this.keptNumber(keepValueQuantity);

    // purchase

    // decimal: purchase price is a decimal field ([maxDecimals]="2"), so a kept value like
    // "2.5" must restore as 2.5, not be truncated to 2. (Quantity above is an integer field.)
    this.purchasePriceModel = this.keptNumber(keepValuePurchasePrice, true);

  }

  private visibleColumnsKey(): string {
    return VisibleColumnsKeyPrefix + (this.productStructure?.id ?? '');
  }

  loadVisibleColumns(): void {
    const raw = this.getKept(this.visibleColumnsKey());
    let arr: string[] = [];
    if (raw) {
      try { arr = JSON.parse(raw); } catch { arr = []; }
    }
    this.visibleColumns = new Set(arr);
  }

  isColumnVisible(field: string): boolean {
    return this.visibleColumns.has(field);
  }

  toggleColumn(field: string): void {
    if (this.visibleColumns.has(field)) {
      this.visibleColumns.delete(field);
    } else {
      this.visibleColumns.add(field);
    }
    // dropStaleOnRefusal: false — this is a layout preference, not a value that gets stamped onto
    // a row and committed, so a refused write must leave the last good layout alone rather than
    // delete it (see writeKeptArea).
    this.setKept(this.visibleColumnsKey(), JSON.stringify([...this.visibleColumns]), false);
  }

  collapsibleColumns(): string[] {
    const attrs = (this.productStructure?.fields ?? [])
      .filter(f => f && f.field && f.field !== 'reserved')
      .map(f => f.field as string);
    const flags = (this.productStructure?.stockfields ?? [])
      .filter(s => s && s.field && s.type === 'FLAG')
      .map(s => s.field as string);
    return [...attrs, ...flags];
  }

  ngOnInit(): void {
    let firstUlt = true;

    this.persistValueOn = this.getKept(KeepHeaderValues) == 'true' ? true : false;

    this.activateRouter.params.pipe().subscribe(rt => this.sessionId = rt && rt['id'] ? parseInt(rt['id']) : undefined);

    this.subs.add(

      this.overLayConected?.overlayOutsideClick.pipe(debounceTime(10)).subscribe(() => {
        this.isOpen = {};
      }),

      this.store.pipe(select(selectFeatureCode), debounceTime(50), distinctUntilChanged()).subscribe(featureCode => {
        this.featureCode = featureCode || undefined;
      }),

      this.dataSource.subscribe(ds => {

        // Defensive belt: even if some upstream dispatch slips past the search guards,
        // never let a fresh dataSource emission rewrite the table while the restore
        // picker is still on screen (the user is mid-decision).
        if (this.draftService.hasPendingDrafts) { return; }

        if (this.getRowTable) {
          let cont = 0;
          ds.data = ds.data.map((d: any) => Object.assign(d, { ...d, idRowTable: cont += 1 })) as [];
        }

        this.sortStatus = {};

        this.clearSelection();

        ds.tableStatus.sort = ds.tableStatus.sort || [];

        this.tableData = ds;

        // Positions compacted: an echoed field with no column must not leave a gap (see the helper).
        this.sortStatus = prioritisedSortFromEcho(ds.tableStatus.sort, this.config?.columnsFields);

        // FIXME: CLICK SEARCH ON FILTER SECTION
        this.sharedService.nextNormalData.pipe(take(1), distinctUntilChanged()).subscribe(normal => {

          if (normal.reload) {

            const productStructure = normal?.crudRequest?.customData?.productStructure;

            this.noPaginationAndSort = false;
            this.canLoadNormal = true;
            this.youCanReload = true;

            if (!this.persistValueOn) {
              this.clearHeaderTooling();
            }

            if (productStructure && this.productStructure && productStructure.id != this.productStructure.id) {
              // Only the structure-scoped half. With keep-values OFF the branch above has already
              // run the full clear, so this adds nothing; with it ON, the fields the OLD structure
              // declared (and the select-all the deselection below invalidates) are the only ones
              // that have stopped meaning anything — the comment, quantity, warehouse and purchase
              // price are the operator's own values, and dropping them here is what made
              // "keep values" quietly stop working after any structure-changing search.
              this.clearStructureScopedHeaderTooling();

              this.copyProducts.map((d) => {
                d.languageRow = undefined;
                d.conditionRow = undefined;
                d.holoRow = undefined;
                d.active = false;
                return d;
              });
            }

          }
        });

        if (this.canLoadNormal) {

          this.copyProducts = [...this.tableData.data.map((d: any, i: any) => {


            if (!d.editable || isEmptyObject(d.editable)) {
              d.editable = {};
            }

            d.editable[TypeEditTable.COMMENT] = d.editable[TypeEditTable.COMMENT] != undefined ? d.editable[TypeEditTable.COMMENT]  :  true;

            d.editable[TypeEditTable.QUANTITY] = d.editable[TypeEditTable.QUANTITY] != undefined ? d.editable[TypeEditTable.QUANTITY]  :  true;

            d.editable[TypeEditTable.PURCHASEPRICE] = d.editable[TypeEditTable.PURCHASEPRICE] != undefined ? d.editable[TypeEditTable.PURCHASEPRICE]  :  true;

            d.editable[TypeEditTable.WAREHOUSES] = d.editable[TypeEditTable.WAREHOUSES] != undefined ? d.editable[TypeEditTable.WAREHOUSES]  :  true;

            d.editable[TypeEditTable.HOLOS] = d.editable[TypeEditTable.HOLOS] != undefined ? d.editable[TypeEditTable.HOLOS]  :  true;

            d.editable[TypeEditTable.LANGUAGE] = d.editable[TypeEditTable.LANGUAGE] != undefined ? d.editable[TypeEditTable.LANGUAGE]  :  true;

            d.editable[TypeEditTable.CONDITION] = d.editable[TypeEditTable.CONDITION] != undefined ? d.editable[TypeEditTable.CONDITION]  :  true;

            return d;
          })];

          this.loadStructure();

          // Keep-values on + select-all active: select the freshly-loaded rows and apply the
          // kept header values via the canonical select-all routine (DRY with the select-all
          // toggle). The lookup arrays (languages/conditions/holos) are attached asynchronously
          // by getValues(), so the lookup fields are (re)applied there once available; this call
          // handles selection plus the non-lookup values (comment/quantity/warehouse/purchase/flags).
          // Deferred to the next tick: it marks all rows valid, flipping the template's
          // allsValid()/allsValidValue, which would otherwise trigger NG0100 during this CD cycle.
          if (this.persistValueOn && this.productSelectValueAll) {
            setTimeout(() => this.loadStructureForSelectAll(true), 0);
          }
        }


        if (this.firstLoads) {
          this.firstLoads = false;
        }

        if (firstUlt) {
          firstUlt = false;

          if (this.persistValueOn) {
            this.loadHeaderValues();
          }

          this.startAutosave();

          // The picker is owned by SetInsertConfComponent (mounts before us).
          // If the user picked Restore there, the conf stashed the draft in
          // the service and dispatched its filter to make us mount; consume
          // it here and overwrite the just-loaded server rows with the
          // draft's items.
          const pendingRestore = this.draftService.consumePendingRestore();
          if (pendingRestore) {
            this.applyPendingRestore(pendingRestore);
          }
        }

        this.setInsertService.youCanClickButtonReload.next(false);

      })
    );

    this.init();
    this.setAvailable = false;

  }

  showImage(is: any) {
    Object.keys(this.isOpen).forEach(d => {
      if (this.isOpen[is] != this.isOpen[d]) {
        this.isOpen[d] = false;
      } else {
        // faccio qualcosa

      }
    });
    this.isOpen[is] = !this.isOpen[is]
  }

  ngAfterViewInit() {

    this.subs.add(
      merge(
        this.sort,
        this.paginator?.page.pipe(debounceTime(environment.defaultDebounceTime), distinctUntilChanged())
      ).pipe(
        map(() => {
          // Paging or sorting replaces the whole visible set: bring the table back to the top so the
          // reader is not left halfway down unrelated rows. Same stream, so both triggers are covered.
          this.scrollToTop.toTop(this.host);
          const tableStatus: TableStatus = this.tableData.tableStatus;
          this.selectionStatus = {};

          this.selection = { all: false, rows: [] };

          this.rowSelect.emit(this.selection);

          if (this.paginator && this.config) {
            this.config.pageSize = this.paginator.pageSize;
            tableStatus.page = {
              pageIndex: this.paginator.pageIndex,
              pageSize: this.paginator.pageSize,
              length: this.paginator.length
            };
          }

          tableStatus.sort = _.sortBy(Object.values(this.sortStatus), 'position').map((sortItem: SortItem) => {
            return { field: sortItem.field.sortExpression, direction: sortItem.direction };
          });

          return tableStatus;
        })
      ).subscribe(tableStatus => {
        this.status.emit(tableStatus);
      })
    );
  }

  ngOnDestroy() {

    this.subs2.unsubscribe();
    this.subs.unsubscribe();

  }

  clearSelection() {
    this.selectionStatus = {};
    this.selection = { rows: [], all: false };
  }

  get pageIndex() {

    return this.valuePagueIndex

  }

  set pageIndex(v: any) {

    this.valuePagueIndex = v;

  }

  /** Counts (and gates) the "save N items" button. The row test MUST be the one `setAll` gates
   *  the bulk with: with the two out of step the button offered to save rows the bulk silently
   *  dropped, and the success path then reset the grid and deleted the draft — so the row was
   *  gone with no error, where before the change the backend at least rejected the batch loudly.
   *  Hence `canSaveRow`, the same call `setAll` and the per-row button make, not a second
   *  hand-written copy of it. (`reset()` is scoped to the committed rows as well, so even a row
   *  the wire-level `filterFN` belt drops after that gate keeps what the operator typed.)
   *
   *  `!isRowSaving` is part of that same gate, not an extra: `setAll`'s snapshot excludes a row
   *  whose per-row POST is on the wire (it would book the movement twice), so counting it here
   *  offered a press that was a guaranteed NO-OP — with the only counted row in flight the button
   *  read "save 1 item" and a click produced no spinner, no toast and no request (the
   *  empty-snapshot early return). Counting with the bulk's own gate makes the row drop out of
   *  the count — and the button hide at zero — for the round trip instead. */
  allsValid() {
    const v = this.copyProducts.filter(item =>
      this.canSaveRow(item as { [k: string]: any } | undefined)
      && !this.isRowSaving(item as { [k: string]: any } | undefined));

    this.allsValidValue = v.length;

    return v && v.length > 0;
  }

  productGestioneFieldsAll(field: string) {

    const me = this;

    return {

      get productFieldAll() {

        return me.valueFiledAll[field];

      },

      set productFieldAll(value: number | undefined) {
        me.valueFiledAll[field] = value;

        me.setKept(keepValue + field, me.valueFiledAll[field]);

        if (me.suppressHeaderPaint) { return; }

        me.copyProducts.map((d) => {

          if (d && d.active && d.editable && d.editable[TypeEditTable.HOLOS]) {
            d.holoRow = d.holos?.find(p => p.id == me.valueFiledAll['holoRow']);
          }

          if (d && d.active && d.editable && d.editable[TypeEditTable.LANGUAGE]) {
            d.languageRow = d.languages?.find(p => p.id == me.valueFiledAll['languageRow']);
          }

          if (d && d.active && d.editable && d.editable[TypeEditTable.CONDITION]) {
            d.conditionRow = d.conditions?.find(p => p.id == me.valueFiledAll['conditionRow']);
          }
          return d;
        });

      }


    }


  }


  productGestione(index: any, isManual: boolean, idProductIN?: number, inputValue?: any) {

    const me = this;

    return {
      get productSelect() {
        return me.copyProducts[index].active;
      },
      set productSelect(v: boolean | undefined) {
        me.productSelectValue[index] = v;
        me.copyProducts[index].active = me.productSelectValue[index];

        // for comment
        if (me.copyProducts[index].editable && (me.copyProducts[index].editable as {
          [key: string]: any
        })[TypeEditTable.COMMENT]) {
          me.productGestione(index, false).productComment = me.comentsValue;

        }
        // for quantity

        if (me.copyProducts[index].editable && (me.copyProducts[index].editable as {
          [key: string]: any
        })[TypeEditTable.QUANTITY]) {
          me.productGestione(index, false).productQuantity = me.quantityValue;

        }

        // for purchasePrice

        if (me.copyProducts[index].editable && (me.copyProducts[index].editable as {
          [key: string]: any
        })[TypeEditTable.PURCHASEPRICE]) {
          me.productGestione(index, false).productPurchasePrice = me.purchasePriceValue;

        }


        // fields
        Object.keys(me.valueFiledAll)?.forEach(dField => {
          if (me.valueFiledAll && me.valueFiledAll[dField] != undefined) {

            // FIXME: meter la lista de campos

            if (me.copyProducts[index].editable && me.copyProducts[index].editable?.[dField]) {
              (me.copyProducts[index] as { [k: string]: any })[dField] = me.valueFiledAll[dField];
            }


            if (me.copyProducts[index].editable && me.copyProducts[index].editable?.[TypeEditTable.HOLOS]) {
              if (me.valueFiledAll['holoRow'] != undefined) {
                me.productGestione(index, false).entityValueHolos = me.valueFiledAll['holoRow'];
              }
            }

            if (me.copyProducts[index].editable && me.copyProducts[index].editable?.[TypeEditTable.LANGUAGE]) {
              if (me.valueFiledAll['languageRow'] != undefined) {
                me.productGestione(index, false).entityValueLingua = me.valueFiledAll['languageRow'];
              }
            }
            if (me.copyProducts[index].editable && me.copyProducts[index].editable?.[TypeEditTable.CONDITION]) {
              if (me.valueFiledAll['conditionRow'] != undefined) {
                me.productGestione(index, false).entityValueCondition = me.valueFiledAll['conditionRow'];
              }
            }
          }

        });


        if (me.copyProducts[index].editable && me.copyProducts[index].editable?.[TypeEditTable.WAREHOUSES]) {
          // me.entity[index] = me.entityAll;
          (me.copyProducts[index] as { [k: string]: any })['warehouseRow'] = me.entityAll;
        }
      },

      get productComment(): string | undefined {
        return me.copyProducts[index].comment
      },
      set productComment(v: string | undefined) {
        me.copyProducts[index].comment = v;
        if (isManual) {
          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {
            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.COMMENT] = false;
          }
        }
      },


      get productQuantity(): number | null | undefined {
        return me.copyProducts[index]['quantity']
      },

      set productQuantity(v: number | null | undefined) {
        // The setter accepts the null the number directive emits, but the row model keeps its
        // `number | undefined` shape rather than letting null spread into every consumer of
        // `copyProducts` (getModel, filterFN, the draft payload). This is not the only place that
        // has to say so: `loadStructureForSelectAll` paints the header value onto the rows
        // directly, without going through this setter, and normalises it the same way — every
        // write of a nullable header field into a row owes the same `?? undefined`.
        me.copyProducts[index]['quantity'] = v ?? undefined;
        if (isManual) {
          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {
            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.QUANTITY] = false;
          }
        }
      },

      get productPurchasePrice(): number | null | undefined {
        return me.copyProducts[index]['purchasePrice']
      },

      set productPurchasePrice(v: number | null | undefined) {
        // Normalised for the same reason as productQuantity above.
        me.copyProducts[index]['purchasePrice'] = v ?? undefined;
        if (isManual) {
          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {
            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.PURCHASEPRICE] = false;
          }
        }
      },

      set entityValueWarehouse(id: number | undefined) {
        if (isAutoWarehouse({ id })) {
          (me.copyProducts[index] as { [k: string]: any })['warehouseRow'] = AUTO_WAREHOUSE;
          me.errorCustom[index + '_' + idProductIN] = false;
          if (isManual && me.copyProducts[index] && _.isObject(me.copyProducts[index].editable)) {
            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.WAREHOUSES] = false;
          }
          return;
        }

        (me.copyProducts[index] as {
          [k: string]: any
        })['warehouseRow'] = (me.copyProducts[index])['warehouses']?.find((w: any) => w.id == id);

        if ((me.copyProducts[index] as { [k: string]: any })['warehouseRow'] && (me.copyProducts[index] as {
          [k: string]: any
        })['warehouseRow']?.id != undefined) {
          me.errorCustom[index + '_' + idProductIN] = false;
        } else {
          me.errorCustom[index + '_' + idProductIN] = true;
          (me.copyProducts[index] as {
            [k: string]: any
          })['warehouseRow'] = ((me.copyProducts[index].warehouses as Warehouse[]).map(n => {
            if (id != undefined && (n.id as number)?.toString().includes(id.toString() as string)) {
              const a: any = { id: '9999999999___santiagolegustaelWarehouse', name: '' };
              return a;
            }
            return;
          })).find(d => d && d.id != undefined);
          setTimeout(() => {
            (me.copyProducts[index] as { [k: string]: any })['warehouseRow'] = undefined;
            me.errorCustom[index + '_' + idProductIN] = true;

          }, 0);
        }

        if (isManual && !me.errorCustom[index + '_' + idProductIN]) {
          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {
            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.WAREHOUSES] = false;
          }
        } else {

          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {

            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.WAREHOUSES] = true;

            setTimeout(() => {
              me.errorCustom[index + '_' + idProductIN] = false;
            }, 0);

          }

        }
      },

      get entityValueWarehouse(): number | undefined {
        return (me.copyProducts[index] as { [k: string]: any })['warehouseRow']?.id
      },

      set entityValueHolos(id: number | undefined) {
        (me.copyProducts[index] as {
          [k: string]: any
        })['holoRow'] = (me.copyProducts[index])['holos']?.find((w: any) => w.id == id);

        if ((me.copyProducts[index] as { [k: string]: any })['holoRow'] && (me.copyProducts[index] as {
          [k: string]: any
        })['holoRow']?.id != undefined) {

          me.errorCustomHolo[index + '_' + idProductIN] = false;

          if (((me.copyProducts[index] as {
            [k: string]: any
          })['holoRow']?.id?.toString().length == inputValue?.value?.length)) {

          } else {

            if (inputValue) {

              me.errorCustomHolo[index + '_' + idProductIN] = true;

              (me.copyProducts[index] as {
                [k: string]: any
              })['holoRow'] = ((me.copyProducts[index].holos as Holo[])?.map(n => {
                if (id != undefined && (n.id as number)?.toString().includes(id.toString() as string)) {
                  const a: any = { id: '9999999999___santiagolegustaelrHolos', name: '' };
                  return a;
                }
                return;
              })).find(d => d && d.id != undefined);

              setTimeout(() => {
                (me.copyProducts[index] as { [k: string]: any })['holoRow'] = undefined;
                me.errorCustomHolo[index + '_' + idProductIN] = true;
              }, 0);
            }
          }
        } else {
          me.errorCustomHolo[index + '_' + idProductIN] = true;

          (me.copyProducts[index] as {
            [k: string]: any
          })['holoRow'] = ((me.copyProducts[index].holos as Holo[])?.map(n => {

            if (id != undefined && (n.id as number)?.toString().includes(id.toString() as string)) {
              const a: any = { id: '9999999999___santiagolegustaelrHolos', name: '' };
              return a;
            }
            return;
          }))?.find(d => d && d.id != undefined);
          setTimeout(() => {
            (me.copyProducts[index] as { [k: string]: any })['holoRow'] = undefined;
            me.errorCustomHolo[index + '_' + idProductIN] = true;
          }, 0);
        }

        if (isManual && !me.errorCustomHolo[index + '_' + idProductIN]) {
          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {
            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.HOLOS] = false;
          }
        } else {
          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {
            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.HOLOS] = true;

            setTimeout(() => {
              me.errorCustomHolo[index + '_' + idProductIN] = false;
            }, 0);
          }
        }

      },

      get entityValueHolos(): number | undefined {
        return (me.copyProducts[index] as { [k: string]: any })['holoRow']?.id
      },


      set entityValueCondition(id: number | undefined) {

        (me.copyProducts[index] as {
          [k: string]: any
        })['conditionRow'] = (me.copyProducts[index])['conditions']?.find((w: any) => w.id == id);

        if ((me.copyProducts[index] as { [k: string]: any })['conditionRow'] && (me.copyProducts[index] as {
          [k: string]: any
        })['conditionRow']?.id != undefined) {
          me.errorCustomCondizione[index + '_' + idProductIN] = false;

          if (((me.copyProducts[index] as {
            [k: string]: any
          })['conditionRow']?.id?.toString().length == inputValue?.value?.length)) {

          } else {

            if (inputValue) {

              me.errorCustomCondizione[index + '_' + idProductIN] = true;

              (me.copyProducts[index] as {
                [k: string]: any
              })['conditionRow'] = ((me.copyProducts[index].conditions as Condition[])?.map(n => {
                if (id != undefined && (n.id as number)?.toString().includes(id.toString() as string)) {
                  const a: any = { id: '9999999999___santiagolegustaelrConditions', name: '' };
                  return a;
                }
                return;
              }))?.find(d => d && d.id != undefined);
              setTimeout(() => {

                (me.copyProducts[index] as { [k: string]: any })['conditionRow'] = undefined;
                me.errorCustomCondizione[index + '_' + idProductIN] = true;

              }, 0);
            }


          }


        } else {
          me.errorCustomCondizione[index + '_' + idProductIN] = true;
          (me.copyProducts[index] as {
            [k: string]: any
          })['conditionRow'] = ((me.copyProducts[index].conditions as Condition[])?.map(n => {
            if (id != undefined && (n.id as number)?.toString().includes(id.toString() as string)) {
              const a: any = { id: '9999999999___santiagolegustaelrConditions', name: '' };
              return a;
            }
            return;
          })).find(d => d && d.id != undefined);
          setTimeout(() => {
            (me.copyProducts[index] as { [k: string]: any })['conditionRow'] = undefined;
            me.errorCustomCondizione[index + '_' + idProductIN] = true;

          }, 0);
        }

        if (isManual && !me.errorCustomCondizione[index + '_' + idProductIN]) {
          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {
            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.CONDITION] = false;
          }
        } else {

          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {

            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.CONDITION] = true;

            setTimeout(() => {
              me.errorCustomCondizione[index + '_' + idProductIN] = false;
            }, 0);

          }

        }

        // me.allsValid();
        // me.singleValid(index);
      },

      get entityValueCondition(): number | undefined {
        return (me.copyProducts[index] as { [k: string]: any })['conditionRow']?.id
      },

      set entityValueLingua(id: number | undefined) {

        (me.copyProducts[index] as {
          [k: string]: any
        })['languageRow'] = (me.copyProducts[index])['languages']?.find((w: any) => w.id == id);

        if ((me.copyProducts[index] as { [k: string]: any })['languageRow'] && (me.copyProducts[index] as {
          [k: string]: any
        })['languageRow']?.id != undefined) {
          me.errorCustomLingua[index + '_' + idProductIN] = false;


          if (((me.copyProducts[index] as {
            [k: string]: any
          })['languageRow']?.id?.toString().length == inputValue?.value?.length)) {


          } else {

            if (inputValue) {

              me.errorCustomLingua[index + '_' + idProductIN] = true;

              (me.copyProducts[index] as {
                [k: string]: any
              })['languageRow'] = ((me.copyProducts[index].languages as Language[])?.map(n => {
                if (id != undefined && (n.id as number)?.toString().includes(id.toString() as string)) {
                  const a: any = { id: '9999999999___santiagolegustaelrLingua', name: '' };
                  return a;
                }
                return;
              })).find(d => d && d.id != undefined);

              setTimeout(() => {

                (me.copyProducts[index] as { [k: string]: any })['languageRow'] = undefined;
                me.errorCustomLingua[index + '_' + idProductIN] = true;

              }, 0);
            }


          }


        } else {
          me.errorCustomLingua[index + '_' + idProductIN] = true;
          (me.copyProducts[index] as {
            [k: string]: any
          })['languageRow'] = ((me.copyProducts[index].languages as Language[]).map(n => {
            if (id != undefined && (n.id as number)?.toString().includes(id.toString() as string)) {
              const a: any = { id: '9999999999___santiagolegustaelrLingua', name: '' };
              return a;
            }
            return;
          })).find(d => d && d.id != undefined);
          setTimeout(() => {
            (me.copyProducts[index] as { [k: string]: any })['languageRow'] = undefined;
            me.errorCustomLingua[index + '_' + idProductIN] = true;


          }, 0);


        }

        if (isManual && !me.errorCustomLingua[index + '_' + idProductIN]) {

          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {

            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.LANGUAGE] = false;

          }

        } else {

          if (me.copyProducts[index] && me.copyProducts[index].editable != undefined && _.isObject(me.copyProducts[index].editable)) {

            (me.copyProducts[index].editable as { [key: string]: any })[TypeEditTable.LANGUAGE] = true;

            setTimeout(() => {
              me.errorCustomLingua[index + '_' + idProductIN] = false;
            }, 0);

          }

        }

      },

      get entityValueLingua(): number | undefined {
        return (me.copyProducts[index] as { [k: string]: any })['languageRow']?.id
      }

    }

  }


  getChangeForm(f: NgForm) {
    setTimeout(() => {
      Object.keys(f.controls).forEach(item => {
        if ((this.errorCustom[item] && f.controls[item].value)) {
          f.controls[item].reset();
        }
      })
    }, 10);
  }

  // Blocks the scroll wheel from changing the value of the remaining type="number" inputs in
  // this table (migrated appNumberInput text fields are immune, so their (wheel) bindings are
  // now no-ops, but the plain number inputs at lines 150/317/359/399/459 still need this).
  onWheel(event: WheelEvent) {
    event.preventDefault();
  }

  getChangeFormValueCustom(f: NgForm, input: any, event: any) {
    event.preventDefault();

    console.log("event.detail: ", event.detail);
    if(event.detail === undefined) {
      console.log("Non devo fare niente");

    }else{
      console.log("FAccio");

      setTimeout(() => {

        Object.keys(f.controls).forEach(item => {
          if (
            (this.errorCustomHolo[item] && f.controls[item].value != undefined)
            || (this.errorCustomCondizione[item] && f.controls[item].value != undefined)
            || (this.errorCustomLingua[item] && f.controls[item].value != undefined)
          ) {
            f.controls[item].reset();
            input.valueAccessor?.writeValue(undefined);
          }

        })

      }, 10)
    }



  }


  /** Whether a structures-readiness retry of `loadStructure` is already scheduled, so a burst of
   *  dataSource emissions inside the boot window queues one wait rather than one per emission. */
  private structuresRetryPending = false;

  /** @param isStructuresRetry this call IS the deferred re-run scheduled by the readiness guard
   *  below. It bounds the wait to ONE per round: on the timeout branch `isReady()` stays false
   *  forever, and a retry that could schedule another would re-arm a 10s timer for the life of the
   *  mount. */
  private loadStructure(isStructuresRetry = false) {

    // A search ROUND starts here: reassigning `productStructure` rebuilds the header lookups
    // (`*ngFor` over its stockfields), and each of those searches once from its own `ngOnInit`.
    // So this is the only moment new `loadFailed` emissions become possible, and clearing the
    // latch anywhere else can only un-silence the round already in progress — which is what
    // clearing it on each arriving list did: language 500s (toast, latch), condition 200s (latch
    // cleared by its `getValues`), holo 500s (a second toast for the same round). The latch exists
    // because the three lookups fail together whenever the backend is down.
    this.headerLookupFailureReported = false;
    // The previous round's holo answer no longer speaks for these rows — the lookups are rebuilt
    // below and will answer again. See `holoAnswerSettled`.
    this.holoAnswerSettled = false;

    if (this.copyProducts && this.copyProducts.length > 0) {

      this.productStructure = this.productStructureCond;

      if (!this.productStructure) {

        this.productStructure = this.productStructureService.findStructure((this.copyProducts.find((d) => d && d.categoryId && d.brandId)?.categoryId as number), (this.copyProducts.find((d) => d && d.categoryId && d.brandId)?.brandId as number));

      }

      // The structures service fills its two lookup maps from HTTP issued in its own CONSTRUCTOR,
      // and every `findStructure` before those land MISSES — the same boot race `applyPendingRestore`
      // waits out through `productStructuresReady`. The normal path was left on the claim that it
      // "re-runs per `sharedService.nextReloadData` tick, so a miss self-heals": it does not. This
      // method has exactly ONE call site, inside the `canLoadNormal` branch of the dataSource
      // subscribe, so nothing re-runs it until another emission — and a cold load whose grid beats
      // the structures fetch has none coming.
      //
      // What that cost is the whole holo waiver. Both stamps below resolve through `findStructure`
      // and so match no row, while `holoAnswerSettled` was set `true` regardless — so every brand-6
      // row was refused by `canSaveRow` (unknown reads as required, fail-closed), its holo cell
      // hidden by the *ngIf that wants a non-empty list, and `rowValueWarningKey` showed
      // `holoUnknown`: the silent dead end the waiver exists to close, reached through a race. It
      // also threw outright — `this.productStructure` is typed non-nullable but a miss returns
      // `undefined`, and `undefined.allFields` errors the dataSource subscription for the life of
      // the page.
      //
      // So: wait, once, and re-run. `holoAnswerSettled` stays false meanwhile, which is the honest
      // reading — the answer has not arrived — and leaves the rows merely unsaved rather than
      // refused-and-explained-away. On the timeout branch the retry proceeds exactly as this method
      // used to, resolving what can be resolved; the guard below is what keeps it from throwing.
      if (!this.productStructure && !isStructuresRetry && !this.productStructureService.isReady()) {
        this.awaitStructuresThenReload();
        this.loadVisibleColumns();
        return;
      }

      this.productStructure?.allFields?.forEach(field => {
        this.copyProducts.map(product => {

          if (field && field.field != undefined && product.editable != undefined) {
            product.editable[field.field as string] = true;
          }

          return product;
        });
      });

      // A structure that declares no `holo` LOOKUP stockfield renders no holo header lookup at
      // all, so no `getValues` emission can ever stamp `holos` — and unknown means required, which
      // left every brand-6 row of such a structure unsavable by EVERY path (the cell is hidden too:
      // its *ngIf wants a non-empty list) with nothing on screen saying why. Declaring no holo
      // field IS the claim "this structure offers no holos", exactly like a loaded-empty lookup
      // answer, so record it the same way — through the same scoped stamp, so the waiver reaches
      // only the rows of the structure that made the claim, and the row's `rowHoloWaivedKey` notice
      // makes the waiver visible instead of silent.
      if (!this.structureHasHoloLookup(this.productStructure)) {
        this.stampLoadedEmptyHolos(this.copyProducts);
      }
      // A structure that declares no holo lookup renders none, so no emission can ever arrive and
      // the answer is settled the moment the round begins — the rows stamped just above are the
      // answer. Anything else waits for the lookup. See `holoAnswerSettled`.
      this.holoAnswerSettled = !this.structureHasHoloLookup(this.productStructure);
      // And the same claim for rows of a DIFFERENT structure than the grid's, read off each row's
      // own declaration — the stamp above is scoped to `this.productStructure`'s rows, so a mixed
      // search left the others unknown-and-therefore-required with no cell to fill. See
      // `stampStructureDeclaredNoHolos`.
      this.stampStructureDeclaredNoHolos(this.copyProducts);

    } else {
      this.productStructure = undefined;
    }

    this.loadVisibleColumns();
  }

  /** Re-runs `loadStructure` once the structures service can answer — the normal path's half of
   *  the wait `applyPendingRestore` does for the restore path, sharing its `productStructuresReady`
   *  (and so its 10s cap: a structures fetch that never answers must not leave the grid waiting
   *  forever, it must proceed and let the `holoUnknown` notice say the result is incomplete).
   *
   *  Subscribed on `this.subs` so an unmount drops it, and re-entered with `isStructuresRetry` so
   *  it cannot schedule itself again. */
  private awaitStructuresThenReload(): void {
    if (this.structuresRetryPending) { return; }
    this.structuresRetryPending = true;
    this.subs.add(
      this.productStructuresReady().pipe(take(1)).subscribe(() => {
        this.structuresRetryPending = false;
        this.loadStructure(true);
      }),
    );
  }


  goToPage(ev: KeyboardEvent | Event) {


    const quantitaPage = this.tableData.tableStatus.page.length / this.tableData.tableStatus.page.pageSize;
    let value = parseFloat((ev.target as any)?.value);

    const max = Math.ceil(quantitaPage);


    if ((value - 1) >= max) {

      value = max;
      this.dialogService.openSnack(this.translateService.instant('common.message.noMorePages', { max }), '', 5000);

    }

    if ((quantitaPage + 1) >= value || _.isNaN(value)) {
      this.paginator.pageIndex = isNaN(value) ? 0 : (value - 1);

      this.paginator.page.next({
        pageIndex: this.paginator.pageIndex,

        pageSize: this.paginator.pageSize,

        length: this.paginator.length
      });

    } else {
      this.dialogService.openSnack(this.translateService.instant('common.message.noMorePages', { max }), '', 5000);
    }
  }

  getActions(type: string): TableAction[] {
    return this.actions[type];
  }


  public showColor(v: string) {
    return convertirAHexadecimal(v.toLowerCase());
  }


  private init() {
    this.actions = {};

    if (this.config && !this.config.columnsFields && !this.displayedColumns) {
      this.displayedColumns = ['no_col_defined'];
    }
    if (this.config && !this.config.columnsFields && this.displayedColumns) {
      this.config.columnsFields = this.displayedColumns.map(value => new TableField(value, undefined, 'common.' + value));
    } /*else if (!this.displayedColumns && this.config.columnsFields) {
      this.displayedColumns = this.config.columnsFields.map( value => value.id);
    }*/

    this.loadConfig();

    this.store.pipe(select(selectAuth)).subscribe(auth => {
      // this.rolesProp = auth && auth.roles && auth.roles.length > 0 ? [...auth.roles] : [];
      this.fullAuth = auth;
      this.autoForced = isAutoForced(auth?.roles as string[]);

      if (this.fullAuth && this.fullAuth.username) {
        this.validKeyValue = KEYCONSTANTSETINSERT;
      }
    });

  }

  /** True when the operator has put SOMETHING into this row — the draft's admission test.
   *
   *  Deliberately looser than `canSaveRow`/`filterFN`, which answer "may this row be committed".
   *  A draft exists to survive a reload, and a half-filled row is exactly what there is no other
   *  copy of: gating the draft on the save predicate meant a row with a condition, a language and
   *  a warehouse but no usable quantity yet was simply never written, so a crash between two
   *  autosave ticks lost the work with the restore picker offering nothing. What the draft must
   *  NOT contain is the untouched search results — hence a test for input rather than no test.
   *
   *  "Input" means a value the operator put into THIS CELL, and the per-cell `editable` flags are
   *  how the grid already records exactly that: every manual row-cell setter (quantity, price,
   *  comment, the lookups, the warehouse, `setValueField` for flags) marks its cell
   *  `editable[FIELD] = false` — "user owns this, don't overwrite from header" — while every
   *  header/select-all paint gates on the flag being true and leaves it true. Testing the VALUE
   *  alone read a header-painted page as operator work: select-all plus a header quantity made
   *  all 100 untouched rows draft-eligible, so every autosave POSTed a whole-page draft,
   *  `settleDraftAfterCommit()` always found "rows remaining", and the restore picker followed
   *  every successful save offering rows the operator never touched. A restored draft keeps
   *  counting through the same test: its stored load-shape `editable` marks the filled cells
   *  false (see `getModel`). The value test stays alongside ownership — a manual EDIT that ends
   *  in clearing the box marks the cell owned without leaving anything to restore. */
  private hasRowInput(row: { [k: string]: any } | undefined | null): boolean {
    if (!row) {
      return false;
    }
    const ed = row['editable'];
    const owned = (field: string): boolean => !!ed && _.isObject(ed) && (ed as { [k: string]: any })[field] === false;
    if (row['quantity'] != undefined && owned(TypeEditTable.QUANTITY)) {
      return true;
    }
    if (row['purchasePrice'] != undefined && owned(TypeEditTable.PURCHASEPRICE)) {
      return true;
    }
    if (row['comment'] && owned(TypeEditTable.COMMENT)) {
      return true;
    }
    if (row['languageRow'] && owned(TypeEditTable.LANGUAGE)) {
      return true;
    }
    if (row['conditionRow'] && owned(TypeEditTable.CONDITION)) {
      return true;
    }
    if (row['holoRow'] && owned(TypeEditTable.HOLOS)) {
      return true;
    }
    // With ownership in the test, a per-row warehouse pick CAN be remembered — the old exclusion
    // existed only because a painted destination was indistinguishable from a picked one.
    if (row['warehouseRow'] && owned(TypeEditTable.WAREHOUSES)) {
      return true;
    }
    // A flag counts when it is ON and the operator toggled it (`setValueField` marks the cell) —
    // `loadHeaderValues` writes `false` and the header's `setValueFieldAll` paints without
    // claiming ownership, so neither admits a row on its own.
    return !!this.productStructure?.stockfields?.some(field =>
      !!field.field && row[field.field as string] === true && owned(field.field as string));
  }

  getValid(products: Product[]) {
    // Filter on the ROW, then build the models: `hasRowInput` reads `warehouseRow`/`comment` and
    // the structure's flag fields, several of which getModel does not carry into the non-load
    // shape at all. The models themselves are still the draft's payload, unchanged. The restored
    // copy re-enters through the first arm, because the load shape marks every stored value's cell
    // owned.
    //
    // THE DRAFT MAY NEVER BE NARROWER THAN WHAT A SAVE CARRIES, hence the second arm: `setAll`
    // snapshots on `canSaveRow && !isRowSaving` and reads neither ownership nor `active`, so every
    // row that predicate passes is committed by Save all and must therefore also be drafted. An
    // ownership-only admission excluded the whole select-all workflow — every select-all path
    // writes `active` directly and every header setter paints with `isManual = false`, so a
    // hundred rows completed from the header owned no cell between them: the button read "save 100
    // items", `buildDraftPayload()` yielded zero, the autosave's non-empty filter dropped every
    // tick and `settleDraftAfterCommit()` deleted the draft outright. A crash before Save lost the
    // page with the picker offering nothing.
    //
    // It does NOT reopen the round-6 bug (a whole untouched page in the draft, putting the restore
    // picker after every save), because `canSaveRow` is the COMPLETE test, not a per-cell value
    // test: a page painted with a header quantity alone still has no language, condition or
    // destination and stays out, and a search result carries none of the four on arrival. Once the
    // header has painted all of them the rows ARE the commit, so the next Save all clears them and
    // the settle finds nothing remaining — the picker only reappears for rows a commit left behind,
    // which is what it is for.
    return (products as any[])
      .filter(p => this.hasRowInput(p) || this.canSaveRow(p))
      .map(a => this.getModel(a, true));
  }

  private buildDraftPayload(): Loads {
    // Read straight off `copyProducts`, for the reason `setAll` gives at length: the deep clone
    // this used to take copied every row's attached `languages`/`conditions`/`holos`/`warehouses`
    // lookup arrays — megabytes of structured clone on the main thread on a large session, on
    // every autosave tick and now on the commit path too. Neither `hasRowInput` nor `getModel`
    // mutates its argument (`getModel` builds `otherEdit` from a spread copy), so it bought
    // nothing.
    const items = this.getValid(this.copyProducts);
    return { items, filter: this.filtersOff };
  }

  /** Settles the draft after a commit: the rows the commit did NOT carry are still on screen and
   *  still have no other copy, so the draft has to be rewritten from what is left rather than
   *  deleted outright.
   *
   *  Deleting unconditionally was right only while a save always cleared the WHOLE grid. Once
   *  `reset()` became scoped to the committed rows, a per-row save left up to a full session's
   *  worth of typed rows on screen and tore down the only persisted copy of them — with
   *  `markJustCommitted()` suppressing the restore picker on top — so anything short of the next
   *  autosave tick (five minutes in production) meant a reload lost the lot.
   *
   *  The request is handed to `SetInsertDraftService.settleAfterCommit`, which owns the
   *  subscription (the first commit navigates to /:id and destroys this component — an
   *  unsubscribe from `this.subs` would abort the request mid-flight, leaving the backend holding
   *  a draft that describes committed rows) and remembers the in-flight request so the next
   *  mount's `listPendingDrafts()` waits for it instead of racing it on the backend: losing that
   *  race offered the PRE-commit draft, whose restore re-commits the rows as duplicate movements.
   *
   *  @returns whether a draft was KEPT (rows remained) rather than deleted. The caller needs it to
   *  decide whether to suppress the next mount's restore picker — see `saveDefinitive`. Reported
   *  synchronously, from the decision rather than from the round-trip: the navigation that mounts
   *  the picker does not wait for the save to come back. The round-trip's actual outcome is not
   *  lost, though — the settle carries it, and `listPendingDrafts` hides this tab's own draft
   *  from a listing it gated on a settle that FAILED (or hung), so a rewrite that never landed
   *  cannot leave the stale pre-commit draft actively on offer one navigation later.
   *
   *  Through `settleRewrite`/`settleDelete` — the service builds the request so it rides the same
   *  per-feature write chain the autosaves use; handing over `saveDraft(...)`'s already-chained
   *  observable would enqueue the write twice. */
  private settleDraftAfterCommit(): boolean {
    const payload = this.buildDraftPayload();
    // `Loads.items` is typed loosely enough to be a non-array Object, and the autosave loop guards
    // it the same way before it saves.
    const remaining = Array.isArray(payload.items) ? payload.items.length : 0;
    if (remaining > 0) {
      this.draftService.settleRewrite(payload);
    } else {
      this.draftService.settleDelete();
    }
    return remaining > 0;
  }

  private startAutosave() {
    // 0 (or negative) disables autosave. Guard required: interval(0) does NOT
    // mean "off" - it emits as fast as the scheduler allows, which would run
    // buildDraftPayload in a tight loop and storm saveDraft via switchMap.
    if (environment.draftAutosaveMs <= 0) {
      return;
    }
    this.subs.add(
      interval(environment.draftAutosaveMs).pipe(
        filter(() => this.router.url.includes('set-insert-out')),
        // Hold autosave while the restore picker is up - never overwrite a draft
        // the user is still deciding about.
        filter(() => !this.draftService.hasPendingDrafts),
        // Hold autosave while a commit (saveDefinitive) is in flight - a tick
        // here could overwrite the draft with mid-reset() state OR land after
        // the post-commit deleteDraft and resurrect the row on the backend.
        filter(() => !this.draftService.isSaving),
        map(() => this.buildDraftPayload()),
        filter(payload => Array.isArray(payload.items) && payload.items.length > 0),
        switchMap(payload => this.draftService.saveDraft(payload).pipe(
          catchError(() => EMPTY),
        )),
      ).subscribe()
    );
  }

  formatValue(values: Product[]) {
    values.map(d => {d.warehouses = this.dataExtra['warehouses']; return d;});

    this.copyProducts = [...values];

    this.store.dispatch(new BaseAction(LayoutActionType.LoadingBlock, false));
  }

  validInput(id: any | undefined, value: number | null) {
    // `id` is the 0-based row index (header apply-to-all calls pass `undefined`). Guard on
    // `id != null`, NOT truthiness — row 0's index is falsy, so `&& id` wrongly routed a 0
    // entered in the FIRST row to the header quantityAll reset instead of clearing that row.
    if (value != null && value <= 0 && id != null) {
      this.productGestione(id, true).productQuantity = undefined;
    } else if (value != null && value <= 0) {
      this.quantityAll = undefined;
    }
  }

  validInputDouble(id: any | undefined, value: number | null) {
    // See validInput: `id != null` so row 0 (falsy index) isn't misrouted to the header.
    if (value != null && value < 0 && id != null) {
      this.productGestione(id, true).productPurchasePrice = undefined;
    } else if (value != null && value < 0) {
      this.purchasePriceModel = undefined;
    }
  }

  saveOnFilter(filter: DynaCrudRequest) {
    if (filter.searchRequest?.pagination) {
      filter.searchRequest.pagination = _.omit(filter.searchRequest.pagination, ['active']);
    }

    setTimeout(() => {
      this.store.dispatch(new BaseAction(DynaConfActionType.FilterChange, { ...filter, code: this.ownerCode, srcTag: 'table-edit-rows' }));
    }, 0);

    setTimeout(() => {
      // 500ms later the active route may no longer be this component's own; the owner
      // code keeps the sort in this feature's slot instead of whatever is active then.
      this.store.dispatch(new BaseAction(DynaConfActionType.PaginationSortChange, { ...filter.searchRequest, code: this.ownerCode, srcTag: 'table-edit-rows' }));
    }, 500);
  }

  private loadConfig() {
    if (this.config) {
      this.selectMode = this.config.selectionMode || this.selectMode;
      if (!this.config.pageSize) {
        this.config.pageSize = 20;
      }

      // facciamo vedere sempre il sort clear
      if (this.config.actions || true) {
        const _SELF = this;
        if (this.config.actions) {
          Object.keys(TableActionType).forEach(value => {
            if (_SELF.config?.actions) {
              _SELF.actions[value] = _SELF.config.actions.filter(ac => ac?.type === value)
            }
          });
        }


        if (this.displayedColumns && this.getActions('RECORD').length > 0 && !this.displayedColumns.includes('actions')) {
          this.displayedColumns.push('actions');
        }
      }

      if (this.config.selectionMode === SelectionMode.multiple) {
        if (this.displayedColumns && !this.displayedColumns.includes('multi_selection')) {
          this.displayedColumns.splice(0, 0, 'multi_selection');
        }
      }
    }
  }

  clearSort() {
    this.sortStatus = {};
    this.sortSubject.next(this.sortStatus);
  }


  /**
   * The `aria-sort` direction of the column with this sort id. This grid sorts by several columns
   * at once and ARIA allows the attribute on one header only, so only the PRIMARY sort answers
   * one; a secondary sort is spoken by `sortRank` in the header's text. Takes the sort ID rather
   * than a `TableField`: these three headers are built from literals in the template.
   */
  sortDirection(sortId: string): SortArrowDirection {
    return directionFromPrioritisedSort(this.sortStatus[sortId]);
  }

  /** The column's rank as a SECONDARY sort (2, 3, ...), or `null`. See `sortDirection`. */
  sortRank(sortId: string): number | null {
    return secondarySortRank(this.sortStatus[sortId]);
  }

  /** A secondary sort's direction, read beside `sortRank`. */
  sortRankDirection(sortId: string): SortArrowDirection {
    return secondarySortDirection(this.sortStatus[sortId]);
  }

  setSort(columnField: ColumnFieldNormal) {
    if (this.noPaginationAndSort) {
      return;
    }
    const value = new TableField(columnField.$id, undefined, '', columnField.$id, columnField.$sortable, columnField.$sortExpression || undefined /*... atrrb, others*/)
    if (!value || !value.sortable) {
      return;
    }
    const sortItem: SortItem = this.sortStatus[value.id];
    // prima volta
    if (!sortItem) {
      this.sortStatus[value.id] = {
        field: value,
        position: Object.keys(this.sortStatus).length,
        direction: SortDirection.ASC
      };
    } else if (sortItem && sortItem.direction === SortDirection.ASC) {
      sortItem.direction = SortDirection.DESC;
    } else {
      this.sortStatus[value.id] = undefined as any;
      delete this.sortStatus[value.id];
    }
    _.sortBy(Object.values(this.sortStatus), 'position').forEach((si: SortItem, index: number) => si.position = index);
    this.sortSubject.next(this.sortStatus);
  }

  isSorted(value: Object) {
    return Object.keys(value) && Object.keys(value).length && Object.keys(value).length > 0;
  }

  /** Resolves once `ProductStructureService` can answer `findStructure`, or once the wait has gone
   *  on long enough that answering badly beats not answering at all.
   *
   *  The service fills its two lookup maps from HTTP issued in its own CONSTRUCTOR, and every
   *  `findStructure` call before those land misses. That is survivable on the normal path — it
   *  re-runs per `sharedService.nextReloadData` tick, so a miss self-heals on the next one — and it
   *  is NOT survivable here: the restore path resolves `this.productStructure` and stamps each
   *  row's holo waiver exactly once, inside the single `forkJoin` subscribe below. A restore
   *  landing inside that boot window therefore resolved no structure at all, and the consequences
   *  outlast the mount: `productStructure` stays undefined so every row's cells stay gated off by
   *  the template, and the two holo stamps match no row, so a brand-6 row whose product offers no
   *  holos is unsavable with its holo cell hidden and `rowHoloWaivedKey` unable to fire — the
   *  silent dead-end the waiver exists to close, reached through a race instead of a rename.
   *  `rowStructureCache` cannot rescue it either: it deliberately caches only HITS, which keeps a
   *  miss from being poisoned permanently but gives nothing to retry with when nothing re-asks.
   *
   *  The timeout is what keeps a failed structures fetch from being worse than the race: without
   *  it a service whose HTTP never answers would leave `readySub` on `false` forever and the
   *  restore would simply never paint. On timeout we proceed exactly as this method used to —
   *  resolve what can be resolved, stamp what can be stamped — and the `lookupLoadFailed` /
   *  `holoUnknown` notices below are what tell the operator the result is incomplete. */
  private productStructuresReady(): Observable<boolean> {
    if (this.productStructureService.isReady()) {
      return of(true);
    }
    return race(
      this.productStructureService.isReadyObs().pipe(filter(ready => !!ready), take(1)),
      timer(PRODUCT_STRUCTURES_READY_TIMEOUT_MS).pipe(map(() => false)),
    );
  }

  private applyPendingRestore(draft: PendingDraft) {
    // The block goes up BEFORE the readiness wait, not inside it: the wait is part of what the
    // operator is being made to wait for, and a screen that sat idle through it would be the same
    // silent-busy screen `blockWhileListingDrafts` exists to announce.
    //
    // It goes up THROUGH that operator rather than by a bare dispatch, and the operator wraps the
    // whole chain — the readiness wait AND the lookup fetches. A bare raise here had neither a cap
    // nor a teardown: the wait runs for up to `PRODUCT_STRUCTURES_READY_TIMEOUT_MS` (10s), which is
    // ample time to navigate away, and an unmount takes `this.subs` down with it — so
    // `applyPendingRestoreResolved`, which held the only `LoadingBlock: false` on the path, never
    // ran and the NEXT screen rendered under a full-screen undismissable overlay until some
    // unrelated dispatch happened to clear it. The sibling listing caps its own overlay at
    // `DRAFT_LISTING_BLOCK_MAX_MS` for precisely the reason that a long undismissable overlay is
    // worse than the silence it replaced; this path was introducing a 10s uncapped one.
    //
    // Placed LAST in the pipe, against that operator's own "place it first" guidance: that rule is
    // about a `catchError` hiding the raw error from its `finalize`, and there is none out here —
    // the per-fetch `catchError`s live inside the `forkJoin`, below. What the placement buys is
    // that the block covers the wait as well as the fetches, which is the whole point.
    this.subs.add(
      this.productStructuresReady().pipe(
        switchMap(() => this.applyPendingRestoreResolved(draft)),
        blockWhileListingDrafts(this.store),
      ).subscribe(),
    );
  }

  /** Paints the restored draft once the structures service can answer, and returns the lookup
   *  fetches so the caller's block operator can cover them: this method no longer raises or lowers
   *  the overlay itself, and no longer owns its own subscription (see `applyPendingRestore`). */
  private applyPendingRestoreResolved(draft: PendingDraft): Observable<unknown> {
    // Conf has already dispatched the draft's filter (which triggered this
    // dataSource emission); we don't dispatch again - just paint the draft
    // items over the server rows. The draft itself stays on the backend:
    // restore is non-destructive, and the picker's Delete button (or a
    // commit over this tab's own key) is what removes it.
    const items = (draft.value.items as Product[]) || [];
    if (items.length > 0) {
      this.productStructure = this.productStructureService.findStructure(items[0].categoryId, items[0].brandId);
    }
    // canLoadNormal stays false so subsequent dataSource emissions don't
    // re-overwrite restored rows. Only a manual Search click flips it back
    // to true (via nextNormalData.reload), which is the intended escape.
    this.canLoadNormal = false;
    this.noPaginationAndSort = true;

    // Each row's CELLS are gated in the template by
    //   *ngIf="loadingAll && productStructure && item.warehouses.length > 0
    //          && item.languages.length > 0 && item.conditions.length"
    // The draft only stored picked values (languageRow, conditionRow, ...),
    // not the lookup lists themselves. Instead of racing the header
    // lookup-field components' (getValues) emissions, fetch the lookups we
    // need synchronously here for THIS productStructure's LOOKUP stockfields,
    // apply them to every restored item, then paint into copyProducts and
    // flip loadingAll.
    const lookupFields = (this.productStructure?.stockfields || [])
      .filter((f: any) => f && f.type === 'LOOKUP' && f.source);

    const itemAny = items as any[];

    // Always include the warehouse fetch in the same forkJoin. Default-list
    // kicks off its own warehouse search AFTER it emits to dataSource (see
    // default-list.component.ts: dataSourcetSub.next(ret) fires synchronously
    // while the warehouse subscribe is still in flight), so dataExtra['warehouses']
    // may still be undefined when our restore lands. Without fetching warehouses
    // ourselves the row template's *ngIf="item.warehouses.length > 0" gate
    // fails intermittently (race depends on which HTTP returns first) and the
    // restored table renders empty cells. Fetching here guarantees we have
    // all three lookups before painting copyProducts.
    // A FAILED fetch stamps `entities: null` — i.e. nothing — where a successful-but-empty one
    // stamps `[]`. The two must stay distinguishable: `canSaveRow` reads a LOADED empty `holos`
    // array as "this product offers no holos" and drops the brand-6 holo requirement, so a
    // `catchError` that fabricated `[]` switched that guard off for every restored row whenever
    // the holo lookup request failed — the rows saved happily with no variant recorded, silently.
    // Leaving the list unstamped keeps it UNKNOWN, and unknown means required (the row's cells
    // stay gated off until a re-search reloads the lookups, which is the fail-closed behaviour).
    //
    // Only a response whose `data` IS an array counts as loaded: a 200 whose body carries
    // null/absent data (backend hiccup, serializer edge) proves nothing about what the product
    // offers, and `(ret && ret.data) || []` read exactly that as "loaded empty" — waiving the
    // brand-6 holo requirement on the strength of a malformed body.
    const loadedEntities = (ret: any): any[] | null => (Array.isArray(ret?.data) ? ret.data : null);
    const warehouseFetch = this.dynacrudApiWrapper.getFor('warehouse').search({
      filter: {
        filterBy: {
          operation: OperationType.AND,
          filters: [
            { field: 'obsolete', value: 'false', operation: OperationType.EQ },
            { field: 'virtual', value: 'false', operation: OperationType.EQ },
          ],
        },
      },
    }).pipe(
      map((ret: any) => ({ field: 'warehouse', entities: loadedEntities(ret) })),
      catchError(() => of({ field: 'warehouse', entities: null as any[] | null })),
    );

    const lookupFetches = lookupFields.map((f: any) =>
      this.dynacrudApiWrapper.getFor(f.source).search(undefined).pipe(
        map((ret: any) => ({ field: f.field as string, entities: loadedEntities(ret) })),
        catchError(() => of({ field: f.field as string, entities: null as any[] | null })),
      ),
    );

    return forkJoin([...lookupFetches, warehouseFetch]).pipe(
      tap(results => {
        results.forEach(({ field, entities }) => {
          // language -> languages, condition -> conditions, holo -> holos,
          // warehouse -> warehouses. Matches the per-item array names the
          // row template *ngIf checks and that getValues() writes for the
          // normal (non-restore) flow.
          if (entities === null) { return; } // failed fetch: leave the list unknown, not "empty"
          // A LOADED-EMPTY holo list is the one stamp that WAIVES a requirement (see
          // `stampLoadedEmptyHolos`), so it is scoped to the rows of the structure the claim was
          // made for — `this.productStructure`, resolved from `items[0]`. Stamping it grid-wide
          // here undid, on the restore path, the exact per-structure scoping `getValues` carries on
          // the normal one: a draft spanning more than one category/brand had every row's brand-6
          // holo requirement waived on the strength of an answer about `items[0]`'s structure
          // alone. Every other stamp — and a NON-empty holo list — stays grid-wide: a foreign list
          // can only ADD options, never waive anything.
          if (field === 'holo' && entities.length === 0) {
            this.stampLoadedEmptyHolos(itemAny);
            return;
          }
          const propName = field + 's';
          itemAny.forEach(d => { d[propName] = entities; });
        });
        // AFTER the responses, so it fills only what no answer covered. A structure that declares
        // no `holo` LOOKUP is never fetched above (it contributes no entry to `lookupFields`), so
        // on this path nothing could ever stamp its rows' `holos` — they stayed unknown, i.e.
        // required, with the holo cell hidden and `rowHoloWaivedKey` unable to fire: a restored
        // brand-6 row that could not be saved, had no cell to fill, and said nothing. The normal
        // path has made this claim since `loadStructure`; the restore path was the half that never
        // mirrored it. Same call also covers rows of a structure OTHER than `items[0]`'s, whose own
        // declaration is the only thing that can speak for them here. See
        // `stampStructureDeclaredNoHolos`.
        this.stampStructureDeclaredNoHolos(itemAny);
        // Fail-closed must not also be SILENT. An unstamped list keeps the affected rows gated
        // off (`canSaveRow` reads unknown as required; the row template's *ngIf keeps the cells
        // hidden), and nothing on screen says why — the operator's fully-filled rows just never
        // become savable for the rest of the mount. Say so, and name the way out (a re-search
        // reloads the lookups). `sticky`: it stays until dismissed, because this is the only
        // explanation the operator will get. (Omitting `time` would give it 4000ms — the
        // `openSnack` default — not stickiness.)
        if (results.some(({ entities }) => entities === null)) {
          this.dialogService.openSnack('dialog.loadSetInsert.lookupLoadFailed', { icon: 'warning', sticky: true });
        }
        // Bypass formatValue's d.warehouses = dataExtra['warehouses'] assignment
        // since we just stamped warehouses ourselves and dataExtra may not be
        // populated yet (the race above). Paint copyProducts directly.
        this.copyProducts = [...items];
        // Every list this path can get an answer about has now answered (or failed, above), so a
        // brand-6 row still carrying no `holos` array really is stuck rather than mid-load — see
        // `holoAnswerSettled`.
        this.holoAnswerSettled = true;
        this.loadingAll = true;
      }),
    );
  }

}




export const DRAFT_PREVIEW_ITEMS = 10;

@Component({
  selector: 'dialog-load-set-insert',
  templateUrl: 'dialog-load-set-insert.html',
})
export class DialogLoadSetInsertComponent {
  drafts: PendingDraft[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { drafts: PendingDraft[] },
    public dialogRef: MatDialogRef<DialogLoadSetInsertComponent>,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private draftService: SetInsertDraftService) {
    this.drafts = [...(data.drafts || [])];
  }

  restore(draft: PendingDraft) {
    this.dialogRef.close({ action: 'restore', draft });
  }

  deleteDraft(draft: PendingDraft) {
    // Chained (`deleteDraftChained`), not a raw pass-through: a queued write for the same key
    // fires whether or not anyone subscribes, so an unchained DELETE could complete and then have
    // the queued write re-create, on the backend, the draft the user just deleted. The row leaves
    // the list only when the delete LANDED with the chain intact — on `false` the draft may still
    // exist, and dropping the row would only hide it until the next mount re-lists it. Keeping
    // the row must not be SILENT, though: with no signal at all, a refused delete (offline, a
    // hung prior clamping the chain) read as a dead button, pressed again and again with nothing
    // ever explaining why the row stays. Sticky like the other only-explanation-the-operator-gets
    // toasts — asked for explicitly, since an omitted `time` is 4000ms, not sticky; a delete of a
    // draft the backend no longer holds
    // reports SUCCESS instead (the 404 tolerance in `deleteDraftChained`), so this cannot latch a
    // row undeletable for the dialog's life over a key that is already gone.
    this.draftService.deleteDraftChained(draft.key).subscribe(ok => {
      if (!ok) {
        this.dialogService.openSnack('dialog.loadSetInsert.deleteFailed', { icon: 'warning', sticky: true });
        return;
      }
      this.drafts = this.drafts.filter(d => d.key !== draft.key);
      if (this.drafts.length === 0) {
        this.dialogRef.close();
      }
    });
  }

  preview(draft: PendingDraft) {
    const items = (draft.value.items as any[]) || [];
    this.dialog.open(DraftPreviewDialogComponent, {
      data: {
        brand: draft.brand,
        items: items.slice(0, DRAFT_PREVIEW_ITEMS).map(toDraftPreviewItem),
        total: items.length,
        config: previewConfigForKey(draft.key),
      },
      width: '70%',
      maxHeight: '70vh',
    });
  }

  ignore() {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'dialog-draft-preview',
  template: `
    <div class="d-flex position-relative align-items-center justify-content-between w-100 mb-2">
      <h5 class="m-0">
        {{ 'dialog.loadSetInsert.preview.title' | translate }}
        <ng-container *ngIf="data.brand"> &middot; <span class="text-muted fw-normal">{{ data.brand }}</span></ng-container>
      </h5>
      <div class="d-flex align-items-center gap-2">
        <span *ngIf="data.total > data.items.length" class="small text-muted text-nowrap">
          {{ 'dialog.loadSetInsert.preview.moreItems' | translate:{ count: data.total - data.items.length } }}
        </span>
        <button type="button" mat-icon-button (click)="dialogRef.close()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="preview-grid">
      <div *ngFor="let item of data.items" class="preview-card border rounded">
        <div class="preview-card-frame">
          <img *ngIf="hasImage(item); else placeholder"
               [src]="item.cardData.image | appImageUrl"
               [alt]="item.name"
               loading="lazy"
               class="preview-card-image" />
          <ng-template #placeholder>
            <div class="preview-card-placeholder d-flex align-items-center justify-content-center text-muted">
              <mat-icon>image_not_supported</mat-icon>
            </div>
          </ng-template>

          <span *ngIf="item.quantity != null" class="badge bg-primary preview-card-qty">&times;{{ item.quantity }}</span>
        </div>

        <div class="preview-card-body p-2 d-flex flex-column gap-1">
          <div class="fw-bold text-truncate" [title]="item.name">{{ item.name }}</div>

          <small class="text-muted text-truncate">
            <span *ngIf="item.expansion?.abbreviation" class="badge bg-light text-dark border me-1">{{ item.expansion.abbreviation }}</span>
            <ng-container *ngIf="item.rarity?.englishName || item.rarity?.name">{{ item.rarity.englishName || item.rarity.name }}</ng-container>
          </small>

          <div class="d-flex flex-wrap gap-1 small text-muted preview-card-flags"
               *ngIf="item.flags?.length">
            <span *ngFor="let flag of item.flags" class="badge bg-light text-dark border">{{ flag }}</span>
          </div>

          <dl class="row g-0 m-0 small preview-card-meta">
            <ng-container *ngIf="item.conditionRow?.name">
              <dt class="col-5 text-muted fw-normal">{{ 'common.condition' | translate }}</dt>
              <dd class="col-7 mb-0 text-truncate" [title]="item.conditionRow.name">{{ item.conditionRow.name }}</dd>
            </ng-container>
            <ng-container *ngIf="item.languageRow?.name">
              <dt class="col-5 text-muted fw-normal">{{ 'common.language' | translate }}</dt>
              <dd class="col-7 mb-0 text-truncate" [title]="item.languageRow.name">{{ item.languageRow.name }}</dd>
            </ng-container>
            <ng-container *ngIf="config.showPrice && item.purchasePrice != null">
              <dt class="col-5 text-muted fw-normal">{{ 'common.price' | translate }}</dt>
              <dd class="col-7 mb-0">{{ item.purchasePrice }}</dd>
            </ng-container>
          </dl>

          <!-- Warehouse on its own full-width line: long names (and transfer's
               'from → to') need room to wrap rather than being clipped. -->
          <div *ngIf="config.warehouse !== 'none' && warehouseText(item)"
               class="small preview-card-wh text-break" [title]="warehouseText(item)">
            <span class="text-muted">{{ 'common.warehouse' | translate }}:</span> {{ warehouseText(item) }}
          </div>

          <small *ngIf="item.comment" class="text-muted fst-italic text-truncate" [title]="item.comment">
            &laquo; {{ item.comment }} &raquo;
          </small>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .preview-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 12px;
    }
    .preview-card {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      transition: box-shadow .15s ease, transform .15s ease;
    }
    .preview-card:hover {
      box-shadow: 0 2px 8px var(--g15-shadow);
      transform: translateY(-1px);
    }
    .preview-card-frame {
      position: relative;
      aspect-ratio: 5 / 7;
      background: var(--g15-scrim);
      overflow: hidden;
    }
    .preview-card-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .preview-card-placeholder {
      width: 100%;
      height: 100%;
    }
    .preview-card-placeholder mat-icon {
      font-size: 32px;
      width: 32px;
      height: 32px;
    }
    .preview-card-qty {
      position: absolute;
      bottom: 6px;
      right: 6px;
      font-size: 0.75rem;
      font-weight: 600;
    }
    .preview-card-body {
      font-size: 0.75rem;
    }
    .preview-card-flags .badge { font-weight: 400; }
    .preview-card-meta dt,
    .preview-card-meta dd {
      padding: 0;
    }
    .preview-card-wh {
      overflow-wrap: anywhere;
    }
    /* The dark Material dialog makes Bootstrap's grey .text-muted nearly
       invisible on the dialog surface - card labels (condition, language,
       warehouse, ...), rarity, comment, the header brand, and the "+N more
       items" indicator. Force legible white across the whole dialog. Needs
       !important + :host specificity to beat Bootstrap's own !important. */
    :host .text-muted {
      color: var(--g15-on-surface) !important;
    }
  `],
})
export class DraftPreviewDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { brand?: string; items: any[]; total: number; config?: DraftPreviewConfig },
    public dialogRef: MatDialogRef<DraftPreviewDialogComponent>,
    private translateService: TranslateService) {}

  get config(): DraftPreviewConfig {
    return this.data.config ?? DEFAULT_PREVIEW_CONFIG;
  }

  /** Does this card have a picture? Not `item.cardData?.image` truthiness: the stored
      `cardImageNotAvailable` sentinel is a truthy string, so that test showed the bundled
      placeholder for a row with no picture while a null row showed the icon below. */
  hasImage(item: any): boolean {
    return hasStoredImage(item?.cardData?.image);
  }

  /** "from → to" for transfer; whichever name is present if only one. */
  warehouseFromTo(item: any): string {
    const from = item?.warehouseFrom?.name;
    const to = item?.warehouseTo?.name;
    if (from && to) { return from + ' → ' + to; }
    return to || from || '';
  }

  /** The warehouse value to display, per the feature's warehouse mode. The Auto sentinel has no
   *  name of its own, so without its own branch it would render as '' and the template's
   *  `*ngIf="warehouseText(item)"` would drop the whole line - making an Auto row look exactly
   *  like a row with no warehouse chosen at all. */
  warehouseText(item: any): string {
    if (this.config.warehouse === 'fromTo') { return this.warehouseFromTo(item); }
    if (this.config.warehouse === 'single') {
      if (isAutoWarehouse(item?.warehouseRow)) {
        return this.translateService.instant('warehouse.autoAllocation.option');
      }
      return item?.warehouseRow?.name || '';
    }
    return '';
  }
}
